// Code generated by spellbook: DO NOT EDIT.
import { z } from "zod";

export const Services_attendance_pkg_attendance_AbsenceJustificationSchema = z.enum([
    "dayOff",
    "other",
]);

export const Services_attendance_pkg_attendance_ActionTypeSchema = z.enum([
    "confirmation",
    "modification",
    "pending_validation",
    "refusal",
    "validation",
]);

export const Services_attendance_pkg_attendance_BreakSchema = z.object({
    endDate: z.coerce.date().nullish(),
    startDate: z.coerce.date().nullish(),
    duration: z.number().optional(),
});

export const Services_attendance_pkg_attendance_BreakDateSchema = z.object({
    startDate: z.coerce.date().nullish(),
    endDate: z.coerce.date().nullish(),
});

export const Services_attendance_pkg_attendance_DisputeHistorySchema = z.object({
    managerId: z.string(),
    bySider: z.boolean(),
    byCompany: z.boolean(),
    byInsider: z.boolean(),
    updatedBy: z.string().nullish(),
    startDate: z.coerce.date().nullable(),
    endDate: z.coerce.date().nullable(),
    disputeIsOver: z.boolean(),
    reviewed: z.boolean(),
    breakDates: z.array(Services_attendance_pkg_attendance_BreakDateSchema).nullable(),
    absenceJustification: Services_attendance_pkg_attendance_AbsenceJustificationSchema.nullish(),
    createdAt: z.coerce.date().nullable(),
});

export const Services_attendance_pkg_attendance_DisputeSchema = z.object({
    id: z.string(),
    attendanceId: z.string().optional(),
    companyId: z.string().optional(),
    managerId: z.string().optional(),
    shiftId: z.string().optional(),
    siderId: z.string().optional(),
    taskId: z.string().optional(),
    bySider: z.boolean(),
    byCompany: z.boolean(),
    byInsider: z.boolean(),
    updatedBy: z.string().nullish(),
    disputeIsOver: z.boolean(),
    reviewed: z.boolean(),
    startDate: z.coerce.date().nullish(),
    endDate: z.coerce.date().nullish(),
    breakDates: z.array(Services_attendance_pkg_attendance_BreakDateSchema).nullable(),
    absenceJustification: Services_attendance_pkg_attendance_AbsenceJustificationSchema.nullish(),
    disputeHistory: z.array(Services_attendance_pkg_attendance_DisputeHistorySchema).nullable(),
    createdAt: z.coerce.date().nullish(),
    updatedAt: z.coerce.date().nullish(),
});

export const Services_attendance_pkg_attendance_ModificationJustificationSchema = z.object({
    start: z.string().optional(),
    end: z.string().optional(),
});

export const Services_attendance_pkg_attendance_OriginSchema = z.enum([
    "company",
    "insider",
    "shift",
    "sider",
    "system",
]);

export const Services_attendance_pkg_attendance_ActionSchema = z.object({
    type: Services_attendance_pkg_attendance_ActionTypeSchema,
    origin: Services_attendance_pkg_attendance_OriginSchema.optional(),
    updatedBy: z.string().nullable(),
    updatedAt: z.coerce.date(),
});

export const Services_attendance_pkg_attendance_FormattedValidationSchema = z.object({
    userId: z.string().optional(),
    origin: Services_attendance_pkg_attendance_OriginSchema,
    createdAt: z.coerce.date(),
});

export const Services_attendance_pkg_attendance_StatusSchema = z.enum([
    "att.conflict",
    "att.disputed",
    "att.validated",
    "att.waiting",
]);

export const Services_attendance_pkg_attendance_FormattedHistorySchema = z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    breaks: z.array(Services_attendance_pkg_attendance_BreakSchema).nullish(),
    origin: Services_attendance_pkg_attendance_OriginSchema.optional(),
    updatedBy: z.string().nullish(),
    updatedAt: z.coerce.date(),
    actions: z.array(Services_attendance_pkg_attendance_ActionSchema).nullish(),
    absenceJustification: Services_attendance_pkg_attendance_AbsenceJustificationSchema.nullish(),
});

export const Services_attendance_pkg_attendance_ValidationSchema = z.object({
    validatedAt: z.coerce.date().nullish(),
    userId: z.string().optional(),
});

export const Services_attendance_pkg_attendance_FormattedAttendanceSchema = z.object({
    id: z.string(),
    status: Services_attendance_pkg_attendance_StatusSchema,
    shiftId: z.string().optional(),
    siderId: z.string().optional(),
    disputeId: z.string().nullish(),
    organisationId: z.string(),
    taskId: z.string().optional(),
    taskManagerId: z.string(),
    validation: Services_attendance_pkg_attendance_ValidationSchema.nullish(),
    modificationJustification:
        Services_attendance_pkg_attendance_ModificationJustificationSchema.nullish(),
    absenceJustification: Services_attendance_pkg_attendance_AbsenceJustificationSchema.nullish(),
    history: z.array(Services_attendance_pkg_attendance_FormattedHistorySchema).nullish(),
});

export const Services_attendance_src_types_AbsenceJustificationSchema = z.enum(["dayOff", "other"]);

export const Services_attendance_src_types_TimeSchema = z.coerce.date();

export const Services_attendance_src_types_BreakDateSchema = z.object({
    startDate: z.coerce.date().nullish(),
    endDate: z.coerce.date().nullish(),
});

export const Services_charges_pkg_condition_ProrataSchema = z.number();

export const Services_charges_pkg_invoice_NumberSchema = z.int();

export const Services_charges_pkg_invoice_PaymentSchema = z.enum([
    "card",
    "collectionStatement",
    "SEPA",
    "unknown",
]);

export const Services_charges_pkg_invoice_StatusSchema = z.enum([
    "aborted",
    "cancelled",
    "created",
    "draft",
    "draft_validated",
    "invoiced",
    "paid",
    "pending",
    "rejected",
]);

export const Services_charges_pkg_invoice_ISchema = z.object({
    ID: z.string(),
    Number: Services_charges_pkg_invoice_NumberSchema,
    Year: z.int(),
    Week: z.int().nullable(),
    Month: z.int().nullable(),
    CompanyID: z.string(),
    Payment: Services_charges_pkg_invoice_PaymentSchema,
    Factored: z.boolean(),
    Status: Services_charges_pkg_invoice_StatusSchema,
    TotalExclTax: z.number(),
    TotalExclTaxRounded: z.number().nullable(),
    TotalInclTax: z.number(),
    TotalInclTaxRounded: z.number().nullable(),
    IsInternalInvoice: z.boolean().nullable(),
    SourceInvoiceNumber: z.int(),
    OrderFormMention: z.string(),
    URL: z.string(),
    SendAt: z.coerce.date().nullable(),
    CreatedAt: z.coerce.date(),
});

export const Services_charges_pkg_remunerationpolicy_LunchTicketSenderSchema = z.enum([
    "company",
    "side",
]);

export const Services_charges_pkg_remunerationpolicy_RPSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    additionalMention: z.string(),
    indemnities: z.array(z.string()).nullable(),
    ifmForSeasonal: z.boolean().nullish(),
    partTimeWorkEnabled: z.boolean(),
    cumulativeHourIncreasesEnabled: z.boolean(),
    lunchTicketSender: Services_charges_pkg_remunerationpolicy_LunchTicketSenderSchema.nullish(),
    unworkedPublicHolidaysHoursToPayCap: z.number().nullish(),
    createdAt: z.coerce.date().nullable(),
    updatedAt: z.coerce.date().nullable(),
});

export const Services_charges_pkg_schedule_TagSchema = z.enum([
    "armistice",
    "assomption",
    "dawn",
    "extra",
    "fete-de-la-victoire",
    "fete-du-travail",
    "fete-nationale-francaise",
    "holidays",
    "jeudi-de-l-ascension",
    "jour-de-l-an",
    "lundi-de-paques",
    "lundi-de-pentecote",
    "night",
    "noel",
    "normal",
    "solidarity",
    "sunday",
    "toussaint",
    "twilight",
]);

export const Services_companies_models_api_AdditionalEmailSchema = z.object({
    name: z.string(),
    email: z.string(),
});

export const Services_companies_models_api_AccountingInfoSchema = z.object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    email: z.string().optional(),
    phoneNumber: z.string().optional(),
    additionalEmails: z.array(Services_companies_models_api_AdditionalEmailSchema).nullish(),
});

export const Services_companies_models_api_BillingAddressSchema = z.object({
    street: z.string().optional(),
    postalCode: z.string().optional(),
    city: z.string().optional(),
    country: z.string().optional(),
});

export const Services_companies_models_api_PaymentMethodSchema = z.object({
    type: z.string().optional(),
    last4: z.string().optional(),
    IBAN: z.string().optional(),
    expirationDate: z.coerce.date().nullish(),
});

export const Services_companies_models_api_PaymentInformationsSchema = z.object({
    id: z.string().optional(),
    companyId: z.string().optional(),
    wantOrderForm: z.boolean().nullish(),
    billingAddress: Services_companies_models_api_BillingAddressSchema.optional(),
    tvaNumber: z.string().optional(),
    accountingInfo: Services_companies_models_api_AccountingInfoSchema.optional(),
    paymentMethod: Services_companies_models_api_PaymentMethodSchema.optional(),
    factored: z.boolean().optional(),
    paymentDelay: z.int(),
});

export const Services_companies_pkg_attendanceconfig_TypeSchema = z.enum(["basic", "timesheet"]);

export const Services_companies_pkg_department_StatusSchema = z.enum(["active", "deleted"]);

export const Services_companies_pkg_featurespolicy_EntityTypeSchema = z.enum([
    "account",
    "default",
    "network",
]);

export const Services_companies_pkg_featurespolicy_FeaturePolicySchema = z.object({
    enabled: z.boolean(),
    logasOnly: z.boolean().optional(),
});

export const Services_companies_pkg_featurespolicy_FPSchema = z.object({
    id: z.string(),
    entityId: z.string(),
    entityType: Services_companies_pkg_featurespolicy_EntityTypeSchema,
    docusignSyncPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    preSelectionPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    networkLevelContractsPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    networkLevelAttendancesPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    waAutoNotifyPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    weekendAutoNotifyPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    flexiblePlanningPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    hourlyVolumePolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    seasonalMotivePolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    trainingMotivePolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    planningEditionPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    displayMissionManagerContactInfoPolicy:
        Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    delegateAccountManagementPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    relaxedForeignStudentManagementPolicy:
        Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    flexiblePlanning60hDerogationPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    shortShiftPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    attendancesAutoValidationPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    recommendedSidersPolicy: Services_companies_pkg_featurespolicy_FeaturePolicySchema,
    referenceId: z.string().nullish(),
});

export const Services_lego_pkg_customjobtitle_CSchema = z.object({
    id: z.string(),
    jobTitleId: z.string(),
    organisationId: z.string(),
    name: z.string(),
    deletedAt: z.coerce.date().nullish(),
});

export const Services_lego_pkg_equipment_ESchema = z.object({
    id: z.string(),
    group: z.string(),
    name: z.string(),
    custom: z.boolean(),
});

export const Services_lego_pkg_jobtitle_JSchema = z.object({
    id: z.string(),
    ogrCode: z.string(),
    name: z.string(),
    subtaskIds: z.array(z.string()).nullish(),
    industries: z.array(z.string()).nullable(),
    industryId: z.string(),
    requiredDiplomaIds: z.array(z.string()).nullable(),
    jobTypeId: z.string(),
    usageCount: z.int(),
    romeCodeId: z.string(),
    workerRisks: z.array(z.string()).nullish(),
    agencyRisks: z.array(z.string()).nullish(),
    available: z.boolean().nullish(),
    blocked: z.boolean().nullish(),
    updatedAt: z.coerce.date().nullish(),
    createdAt: z.coerce.date().nullish(),
});

export const Services_lego_pkg_language_LSchema = z.object({
    id: z.string(),
    level: z.string(),
    ISOCode: z.string(),
});

export const Services_lego_pkg_language_LsSchema = z
    .array(Services_lego_pkg_language_LSchema)
    .nullable()
    .transform((val) => val ?? []);

export const Services_lego_pkg_licence_LSchema = z.object({
    id: z.string(),
    name: z.string(),
});

export const Services_lego_pkg_licence_LsSchema = z
    .array(Services_lego_pkg_licence_LSchema)
    .nullable()
    .transform((val) => val ?? []);

export const Services_lego_pkg_motives_ReasonSchema = z.enum([
    "activityIncrease",
    "replacement",
    "seasonalActivity",
    "temporaryContract",
    "trainingAction",
    "waitingRecruitment",
]);

export const Services_lego_pkg_motives_RecruitmentSchema = z.object({
    name: z.string(),
    position: z.string(),
    date: z.coerce.date(),
});

export const Services_lego_pkg_motives_ReplacementSchema = z.object({
    name: z.string(),
    position: z.string(),
    justification: z.string(),
});

export const Services_lego_pkg_motives_MSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    reason: Services_lego_pkg_motives_ReasonSchema,
    justification: z.string(),
    replacements: z.array(Services_lego_pkg_motives_ReplacementSchema).nullish(),
    recruitments: z.array(Services_lego_pkg_motives_RecruitmentSchema).nullish(),
});

export const Services_lego_pkg_risk_RSchema = z.object({
    id: z.string(),
    group: z.string(),
    name: z.string(),
    value: z.string().nullish(),
});

export const Services_lego_pkg_risk_RsSchema = z
    .array(Services_lego_pkg_risk_RSchema)
    .nullable()
    .transform((val) => val ?? []);

export const Services_lego_pkg_subtask_SSchema = z.object({
    id: z.string(),
    name: z.string(),
    custom: z.boolean(),
});

export const Services_lego_pkg_subtask_SsSchema = z
    .array(Services_lego_pkg_subtask_SSchema)
    .nullable()
    .transform((val) => val ?? []);

export const Services_lego_pkg_tool_TSchema = z.object({
    id: z.string(),
    name: z.string(),
    custom: z.boolean(),
    level: z.string().nullish(),
});

export const Services_lego_pkg_tool_TsSchema = z
    .array(Services_lego_pkg_tool_TSchema)
    .nullable()
    .transform((val) => val ?? []);

export const Services_locations_pkg_location_UsedAtSchema = z.object({
    isData: z.boolean(),
    dateString: z.string(),
});

export const Services_locations_pkg_location_LSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    postalCode: z.string(),
    city: z.string(),
    lat: z.number(),
    lng: z.number(),
    country: z.string(),
    confirmed: z.boolean(),
    address: z.string(),
    description: z.string(),
    usedAt: Services_locations_pkg_location_UsedAtSchema.nullish(),
    online: z.boolean(),
    favorite: z.boolean(),
    title: z.string().nullish(),
});

export const Services_organisation_pkg_organisation_AddressSchema = z.object({
    line1: z.string(),
    line2: z.string(),
    postalCode: z.string(),
    city: z.string(),
    country: z.string(),
});

export const Services_organisation_pkg_organisation_ConfirmationSchema = z.object({
    date: z.coerce.date(),
    userId: z.string(),
});

export const Services_organisation_pkg_organisation_DaySchema = z.enum([
    "friday",
    "monday",
    "saturday",
    "sunday",
    "thursday",
    "tuesday",
    "wednesday",
]);

export const Services_organisation_pkg_organisation_GoogleSchema = z.object({
    spreadsheetId: z.string(),
});

export const Services_organisation_pkg_organisation_InvoiceInfosSchema = z.object({
    name: z.string(),
    email: z.string(),
    address: Services_organisation_pkg_organisation_AddressSchema.nullable(),
});

export const Services_organisation_pkg_organisation_PaymentMethodSchema = z.object({
    type: z.string(),
    last4: z.string(),
});

export const Services_organisation_pkg_organisation_PricingMethodSchema = z.enum([
    "fixed",
    "variable",
]);

export const Services_organisation_pkg_organisation_ServicesSchema = z.object({
    google: Services_organisation_pkg_organisation_GoogleSchema,
});

export const Services_organisation_pkg_organisation_SlugSchema = z.object({
    base: z.string(),
    index: z.int(),
});

export const Services_organisation_pkg_organisation_FriendlySlugsSchema = z.object({
    slug: Services_organisation_pkg_organisation_SlugSchema,
});

export const Services_organisation_pkg_organisation_StockManagerSchema = z.object({
    sider: z.int(),
    side: z.int(),
});

export const Services_organisation_pkg_organisation_PricingPlanSchema = z.object({
    stockManager: Services_organisation_pkg_organisation_StockManagerSchema,
});

export const Services_organisation_pkg_organisation_UserSchema = z.object({
    id: z.string(),
    status: z.string(),
    roles: z.array(z.string()).nullable(),
    index: z.string().optional(),
    validationToken: z.string().optional(),
    sourceOrganisationId: z.string().optional(),
});

export const Services_organisation_pkg_organisation_WorkingDaysConfigSchema = z.object({
    inheritFromParent: z.boolean(),
    days: z.array(Services_organisation_pkg_organisation_DaySchema).nullable(),
    includePublicHolidays: z.boolean(),
});

export const Services_organisation_pkg_organisation_OSchema = z.object({
    id: z.string(),
    name: z.string(),
    legalRepresentativeName: z.string(),
    tweet: z.string(),
    companySize: z.string(),
    signupOrigin: z.string(),
    website: z.string(),
    logoUrl: z.string(),
    videoUrl: z.string(),
    coverUrl: z.string(),
    users: z.array(Services_organisation_pkg_organisation_UserSchema).nullable(),
    phoneNumber: z.string(),
    slug: z.string(),
    friendlySlugs: Services_organisation_pkg_organisation_FriendlySlugsSchema,
    invoiceInfos: Services_organisation_pkg_organisation_InvoiceInfosSchema,
    headquarters: z.string(),
    paymentMethod: Services_organisation_pkg_organisation_PaymentMethodSchema,
    notPaying: z.boolean(),
    stripeCustomerID: z.string(),
    pricingPlan: Services_organisation_pkg_organisation_PricingPlanSchema,
    sCustomerNumber: z.string(),
    sCustomerType: z.string(),
    services: Services_organisation_pkg_organisation_ServicesSchema,
    workLegalStatus: z.string(),
    siret: z.string(),
    APECode: z.string(),
    pricingMethod: Services_organisation_pkg_organisation_PricingMethodSchema,
    industry: z.string().nullish(),
    pricingId: z.string().nullish(),
    attendanceConfigId: z.string().nullish(),
    remunerationPolicyId: z.string().nullish(),
    vmsConfigurationId: z.string().nullish(),
    workingDaysConfig: Services_organisation_pkg_organisation_WorkingDaysConfigSchema,
    blocked: z.boolean().nullable(),
    groupedInvoices: z.boolean().nullish(),
    interestedOfferTypes: z.array(z.string()).nullable(),
    parentOrganisationIds: z.array(z.string()).nullish(),
    childOrganisationIds: z.array(z.string()).nullish(),
    organisationType: z.string(),
    shopCode: z.string(),
    address: z.string(),
    city: z.string(),
    zip: z.string(),
    legalRules: z.array(z.string()).nullish(),
    features: z.array(z.string()).nullable(),
    indemnitiesConfirmation: Services_organisation_pkg_organisation_ConfirmationSchema.nullish(),
    hoursTypesConfirmation: Services_organisation_pkg_organisation_ConfirmationSchema.nullish(),
    createdAt: z.coerce.date().nullable(),
    updatedAt: z.coerce.date().nullable(),
});

export const Services_task_shifts_pkg_task_ApplicantStatusHistorySchema = z.object({
    status: z.string(),
    date: z.coerce.date(),
});

export const Services_task_shifts_pkg_task_OriginSchema = z.enum(["pixid"]);

export const Services_task_shifts_pkg_task_PreSelectionStatusSchema = z.enum([
    "approved",
    "refused",
    "sent",
]);

export const Services_task_shifts_pkg_task_RecruitmentSchema = z.object({
    name: z.string(),
    date: z.coerce.date(),
    position: z.string(),
});

export const Services_task_shifts_pkg_task_ReplacementSchema = z.object({
    name: z.string(),
    position: z.string(),
    justification: z.string(),
});

export const Services_task_shifts_pkg_task_MotiveSchema = z.object({
    reason: z.string(),
    justification: z.string().nullable(),
    replacements: z.array(Services_task_shifts_pkg_task_ReplacementSchema).nullish(),
    recruitments: z.array(Services_task_shifts_pkg_task_RecruitmentSchema).nullish(),
});

export const Services_task_shifts_pkg_task_StatusSchema = z.enum(["draft", "submitted"]);

export const Services_task_shifts_pkg_task_TypeSchema = z.enum(["delegation", "gestion"]);

export const Services_team_api_dto_AdditionalEmailSchema = z.object({
    name: z.string(),
    email: z.string(),
});

export const Services_team_api_dto_AccountingInfoSchema = z.object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    email: z.string().optional(),
    phoneNumber: z.string().optional(),
    additionalEmails: z.array(Services_team_api_dto_AdditionalEmailSchema).nullish(),
});

export const Services_team_api_dto_BillingAddressSchema = z.object({
    street: z.string().optional(),
    postalCode: z.string().optional(),
    city: z.string().optional(),
    country: z.string().optional(),
});

export const Services_team_api_dto_ChildrenSearchOrgaRespSchema = z.object({
    id: z.string(),
    name: z.string(),
    address: z.string(),
    pictureURL: z.string(),
});

export const Services_team_api_dto_ChildrenSearchReqSchema = z.object({
    q: z.string(),
});

export const Services_team_api_dto_ChildrenSearchRespSchema = z.object({
    Organisations: z.array(Services_team_api_dto_ChildrenSearchOrgaRespSchema).nullable(),
});

export const Services_team_api_dto_ConventionConfirmationSchema = z.object({
    date: z.coerce.date().nullish(),
    userId: z.string(),
});

export const Services_team_api_dto_DayIncludeSchema = z.object({
    holidays: z.boolean().nullish(),
    weekDays: z.boolean().nullish(),
    saturday: z.boolean().nullish(),
    sunday: z.boolean().nullish(),
});

export const Services_team_api_dto_EducationSchema = z.object({
    id: z.string(),
    endYear: z.int(),
    startYear: z.int(),
    degree: z.string().nullable(),
    fieldOfStudy: z.string().nullable(),
    schoolName: z.string().nullable(),
});

export const Services_team_api_dto_ExtraHoursThresholdSchema = z.object({
    threshold: z.int(),
    increase: z.number(),
});

export const Services_team_api_dto_ExtraHoursTypeSchema = z.object({
    thresholds: z.array(Services_team_api_dto_ExtraHoursThresholdSchema).nullable(),
});

export const Services_team_api_dto_FeedBackSchema = z.object({
    id: z.string(),
    name: z.string(),
    comment: z.string(),
    createdAt: z.coerce.date(),
});

export const Services_team_api_dto_CompanyTaskSchema = z.object({
    id: z.string(),
    name: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    workedHours: z.int(),
    positiveFeedbacks: z.array(Services_team_api_dto_FeedBackSchema).nullable(),
});

export const Services_team_api_dto_FlexiblePlanningSchema = z.object({
    id: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    weeklyVolume: z.int(),
    siders: z.int(),
    amplitudeStart: z.string(),
    amplitudeEnd: z.string(),
    include: Services_team_api_dto_DayIncludeSchema,
});

export const Services_team_api_dto_GetPlanningReqSchema = z.object({
    week: z.int(),
    year: z.int(),
});

export const Services_team_api_dto_GetSiderReqSchema = z.object({
    withOngoing: z.boolean().nullable(),
    withTasks: z.boolean().nullable(),
    withExperiences: z.boolean().nullable(),
    withEducations: z.boolean().nullable(),
});

export const Services_team_api_dto_GetTasksNameRespSchema = z.object({
    names: z.array(z.string()).nullable(),
});

export const Services_team_api_dto_IndemnityDistanceThresholdSchema = z.object({
    distance: z.int(),
    amount: z.number().optional(),
});

export const Services_team_api_dto_IndemnityFrequencySchema = z.object({
    type: z.string(),
});

export const Services_team_api_dto_IndemnityHoursPerDayConditionSchema = z.object({
    threshold: z.number(),
});

export const Services_team_api_dto_IndemnitySeniorityConditionSchema = z.object({
    daysThreshold: z.int(),
});

export const Services_team_api_dto_IndemnityTaskTypeConditionSchema = z.object({
    jobTypes: z.array(z.string()).nullable(),
    jobTitles: z.array(z.string()).nullable(),
    taskName: z.string().nullish(),
});

export const Services_team_api_dto_IndemnityZTIConditionSchema = z.object({
    isApplicable: z.boolean(),
});

export const Services_team_api_dto_IndemnityAdvancedParametersSchema = z.object({
    seniority: Services_team_api_dto_IndemnitySeniorityConditionSchema.nullish(),
    hoursPerDay: Services_team_api_dto_IndemnityHoursPerDayConditionSchema.nullish(),
    zti: Services_team_api_dto_IndemnityZTIConditionSchema.nullish(),
    taskType: Services_team_api_dto_IndemnityTaskTypeConditionSchema.nullish(),
});

export const Services_team_api_dto_JobDescriptionTypeSchema = z.enum(["document", "url"]);

export const Services_team_api_dto_JobDescriptionSchema = z.object({
    link: z.string(),
    type: Services_team_api_dto_JobDescriptionTypeSchema,
});

export const Services_team_api_dto_LegalInformationsSchema = z.object({
    name: z.string(),
    businessName: z.string(),
    siret: z.string(),
    apeCode: z.string(),
});

export const Services_team_api_dto_LocationSchema = z.object({
    postalCode: z.string().optional(),
    city: z.string().optional(),
    lat: z.number().optional(),
    lng: z.number().optional(),
    country: z.string().optional(),
    address: z.string().optional(),
});

export const Services_team_api_dto_LunchIndemnityTypeSchema = z.enum(["indemnity", "ticket"]);

export const Services_team_api_dto_LunchIndemnitySchema = z.object({
    _id: z.string(),
    type: Services_team_api_dto_LunchIndemnityTypeSchema,
    amount: z.number(),
    coverRate: z.number().nullish(),
    otherParameters: Services_team_api_dto_IndemnityAdvancedParametersSchema.nullish(),
});

export const Services_team_api_dto_NightHourTypeThresholdSchema = z.object({
    startHour: z.number(),
    endHour: z.number(),
    increase: z.number(),
});

export const Services_team_api_dto_NightHourTypeThresholdsSchema = z
    .array(Services_team_api_dto_NightHourTypeThresholdSchema)
    .nullable()
    .transform((val) => val ?? []);

export const Services_team_api_dto_OngoingTaskSchema = z.object({
    id: z.string(),
    name: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
});

export const Services_team_api_dto_OtherIndemnityCategorySchema = z.enum([
    "events",
    "labor-agreement",
    "other",
    "performances",
    "work-condition",
]);

export const Services_team_api_dto_OtherIndemnityNameSchema = z.enum([
    "christmas-bonus",
    "cold-bonus",
    "diligence-bonus",
    "hardship-bonus",
    "holiday-bonus",
    "other-bonus",
    "productivity-bonus",
    "risk-bonus",
    "target-based-bonus",
    "thirteenth-month-bonus",
    "unhealthy-bonus",
    "year-end-bonus",
]);

export const Services_team_api_dto_OtherIndemnitySchema = z.object({
    _id: z.string(),
    category: Services_team_api_dto_OtherIndemnityCategorySchema,
    name: Services_team_api_dto_OtherIndemnityNameSchema,
    amount: z.number(),
    frequency: Services_team_api_dto_IndemnityFrequencySchema,
    otherParameters: Services_team_api_dto_IndemnityAdvancedParametersSchema.nullish(),
});

export const Services_team_api_dto_PatchLegalInformationsSchema = z.object({
    name: z.string().optional(),
    businessName: z.string().nullable(),
    siret: z.string().optional(),
    apeCode: z.string().optional(),
});

export const Services_team_api_dto_PostLocationReqSchema = z.object({
    id: z.string().nullish(),
    postalCode: z.string().nullish(),
    city: z.string().nullish(),
    lat: z.number().nullish(),
    lng: z.number().nullish(),
    country: z.string().nullish(),
    address: z.string().nullish(),
    description: z.string().nullish(),
    favorite: z.boolean().nullish(),
    title: z.string().nullish(),
});

export const Services_team_api_dto_RegenerateDocumentsReqSchema = z.object({
    documentIds: z.array(z.string()).nullable(),
});

export const Services_team_api_dto_SalarySchema = z.object({
    min: z.int(),
    max: z.int(),
});

export const Services_team_api_dto_PostPermanentContractRequestSchema = z.object({
    jobName: z.string(),
    jobDescription: Services_team_api_dto_JobDescriptionSchema.nullish(),
    salary: Services_team_api_dto_SalarySchema,
    availablePositions: z.int(),
    commentary: z.string().optional(),
    startDate: z.coerce.date(),
    location: Services_team_api_dto_LocationSchema,
});

export const Services_team_api_dto_SearchUsersRespResultSchema = z.object({
    _id: z.string(),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    companyName: z.string(),
    companyId: z.string(),
    isParent: z.boolean(),
});

export const Services_team_api_dto_SearchUsersRespSchema = z.object({
    results: z.array(Services_team_api_dto_SearchUsersRespResultSchema).nullable(),
});

export const Services_team_api_dto_SeniorityIncreaseThresholdSchema = z.object({
    daysThreshold: z.int(),
    increase: z.number(),
});

export const Services_team_api_dto_BankHolidayHoursTypeSchema = z.object({
    increase: z.number(),
    seniority: Services_team_api_dto_SeniorityIncreaseThresholdSchema.nullish(),
    solidarity: Services_charges_pkg_schedule_TagSchema.nullish(),
});

export const Services_team_api_dto_NightHoursTypeSchema = z.object({
    thresholds: Services_team_api_dto_NightHourTypeThresholdsSchema,
    seniority: Services_team_api_dto_SeniorityIncreaseThresholdSchema.nullish(),
});

export const Services_team_api_dto_SideJobByTypeSchema = z.object({
    id: z.string(),
    name: z.string(),
    tasksCount: z.int(),
    workedHours: z.int(),
    WorkedDuration: z.number(),
    positiveFeedbacks: z.array(z.string()).nullable(),
});

export const Services_team_api_dto_SlotSchema = z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    breakDuration: z.int(),
});

export const Services_team_api_dto_SiderSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    pictureUrl: z.string(),
    workedHoursInWeek: z.number(),
    slots: z.array(Services_team_api_dto_SlotSchema).nullable(),
    email: z.string(),
    phoneNumber: z.string(),
});

export const Services_team_api_dto_SubTaskSchema = z.object({
    name: z.string(),
});

export const Services_team_api_dto_ExperienceSchema = z.object({
    companyName: z.string(),
    duration: z.int().nullable(),
    categories: z.array(z.string()).nullish(),
    name: z.string().nullish(),
    subTasks: z.array(Services_team_api_dto_SubTaskSchema).nullable(),
});

export const Services_team_api_dto_GetSiderRespSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    phoneNumber: z.string(),
    email: z.string(),
    pictureUrl: z.string().nullish(),
    ongoing: z.array(Services_team_api_dto_OngoingTaskSchema).nullish(),
    companyTasks: z.array(Services_team_api_dto_CompanyTaskSchema).nullish(),
    jobTypes: z.array(Services_team_api_dto_SideJobByTypeSchema).nullish(),
    experiences: z.array(Services_team_api_dto_ExperienceSchema).nullish(),
    educations: z.array(Services_team_api_dto_EducationSchema).nullish(),
});

export const Services_team_api_dto_SundayHoursTypeSchema = z.object({
    increase: z.number(),
    seniority: Services_team_api_dto_SeniorityIncreaseThresholdSchema.nullish(),
    ztiIncrease: z.number().nullish(),
});

export const Services_team_api_dto_HoursTypesSchema = z.object({
    extra: Services_team_api_dto_ExtraHoursTypeSchema.nullish(),
    night: Services_team_api_dto_NightHoursTypeSchema.nullish(),
    sundays: Services_team_api_dto_SundayHoursTypeSchema.nullish(),
    bankHolidays: Services_team_api_dto_BankHolidayHoursTypeSchema.nullish(),
    valid: z.boolean().nullish(),
});

export const Services_team_api_dto_TaskSchema = z.object({
    id: z.string(),
    name: z.string(),
    siders: z.array(Services_team_api_dto_SiderSchema).nullable(),
    category: z.string(),
    hasContracts: z.boolean().nullable(),
    preSelection: z.boolean().nullish(),
    flexiblePlanning: Services_team_api_dto_FlexiblePlanningSchema.nullish(),
});

export const Services_team_api_dto_PlanningSchema = z.object({
    tasks: z.array(Services_team_api_dto_TaskSchema).nullable(),
});

export const Services_team_api_dto_TranslationSchema = z.object({
    translatedName: z.string(),
    translatedCategory: z.string(),
});

export const Services_team_api_dto_JobTypeSchema = z.object({
    _id: z.string(),
    organisationId: z.string().optional(),
    name: z.string(),
    category: z.string(),
    postingData: z.array(z.partialRecord(z.string(), z.unknown())).nullable(),
    pricing: z.unknown().nullable(),
    demandCategoryId: z.string(),
    supplyCategoryId: z.string(),
    questions: z.array(z.string()).nullable(),
    description: z.string(),
    order: z.int(),
    en: Services_team_api_dto_TranslationSchema,
    fr: Services_team_api_dto_TranslationSchema,
});

export const Services_team_api_dto_GetJobTypesRespSchema = z.object({
    jobTypes: z.array(Services_team_api_dto_JobTypeSchema).nullable(),
});

export const Services_team_api_dto_TransportationIndemnityPersonalCoverSchema = z.object({
    thresholds: z.array(Services_team_api_dto_IndemnityDistanceThresholdSchema).nullable(),
});

export const Services_team_api_dto_TransportationIndemnitySchema = z.object({
    _id: z.string(),
    publicCoverRate: z.number(),
    personalCover: Services_team_api_dto_TransportationIndemnityPersonalCoverSchema.nullish(),
    otherParameters: Services_team_api_dto_IndemnityAdvancedParametersSchema.nullish(),
});

export const Services_team_api_dto_IndemnitiesSchema = z.object({
    lunch: z.array(Services_team_api_dto_LunchIndemnitySchema).nullable(),
    transportation: z.array(Services_team_api_dto_TransportationIndemnitySchema).nullable(),
    other: z.array(Services_team_api_dto_OtherIndemnitySchema).nullable(),
    valid: z.boolean().nullish(),
});

export const Services_team_api_dto_GetRemunerationPolicyRespSchema = z.object({
    hoursTypesConfirmation: Services_team_api_dto_ConventionConfirmationSchema.nullish(),
    indemnitiesConfirmation: Services_team_api_dto_ConventionConfirmationSchema.nullish(),
    hoursTypes: Services_team_api_dto_HoursTypesSchema,
    indemnities: Services_team_api_dto_IndemnitiesSchema,
});

export const Services_team_api_dto_PatchIndemnitiesParamsSchema = z.object({
    lunch: z.array(Services_team_api_dto_LunchIndemnitySchema).nullable(),
    transportation: z.array(Services_team_api_dto_TransportationIndemnitySchema).nullable(),
    other: z.array(Services_team_api_dto_OtherIndemnitySchema).nullable(),
    valid: z.boolean().nullish(),
});

export const Services_vmx_pkg_vms_TypeSchema = z.enum([
    "baps",
    "none",
    "peopulse",
    "pilott",
    "pixid",
]);

export const api_cmd_api_attendance_PostAttendanceDisputePathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_attendance_PostAttendanceDisputeResponseSchema = z
    .array(Services_attendance_pkg_attendance_DisputeSchema)
    .nullable()
    .transform((val) => val ?? []);

export const api_cmd_api_auth_ActivateUserPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_auth_GoogleActivateUserPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_department_DeletePathparamsSchema = z.object({
    organisationId: z.string(),
    id: z.string(),
});

export const api_cmd_api_department_GetPathparamsSchema = z.object({
    organisationId: z.string(),
    id: z.string(),
});

export const api_cmd_api_department_ListPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const api_cmd_api_department_PostPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const api_cmd_api_jobdescription_DelJobDescriptionPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_jobdescription_ListCustomJobTitlesResponseSchema = z
    .array(Services_lego_pkg_customjobtitle_CSchema)
    .nullable()
    .transform((val) => val ?? []);

export const api_cmd_api_jobdescription_ListJobTitleSubtasksPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_jobdescription_ListJobTitleSubtasksResponseSchema = z
    .array(Services_lego_pkg_subtask_SSchema)
    .nullable()
    .transform((val) => val ?? []);

export const api_cmd_api_jobdescription_ListJobTitlesResponseSchema = z
    .array(Services_lego_pkg_jobtitle_JSchema)
    .nullable()
    .transform((val) => val ?? []);

export const api_cmd_api_jobdescription_ListOptionsResponseSchema = z.partialRecord(
    z.string(),
    z.unknown(),
);

export const api_cmd_api_jobdescription_PatchJobDescriptionPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_motive_DelMotivePathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_motive_PostMotiveResponseSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    reason: Services_lego_pkg_motives_ReasonSchema,
    justification: z.string(),
    replacements: z.array(Services_lego_pkg_motives_ReplacementSchema).nullish(),
    recruitments: z.array(Services_lego_pkg_motives_RecruitmentSchema).nullish(),
});

export const api_cmd_api_organisation_GetPaymentInformationsPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const api_cmd_api_organisation_GetRemunerationPolicySettingsPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const api_cmd_api_organisation_GetRemunerationPolicySettingsResponseSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    additionalMention: z.string(),
    indemnities: z.array(z.string()).nullable(),
    ifmForSeasonal: z.boolean().nullish(),
    partTimeWorkEnabled: z.boolean(),
    cumulativeHourIncreasesEnabled: z.boolean(),
    lunchTicketSender: Services_charges_pkg_remunerationpolicy_LunchTicketSenderSchema.nullish(),
    unworkedPublicHolidaysHoursToPayCap: z.number().nullish(),
    createdAt: z.coerce.date().nullable(),
    updatedAt: z.coerce.date().nullable(),
});

export const api_cmd_api_organisation_GetVMSConfigurationPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const api_cmd_api_organisation_ListProspectSidersPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_organisation_ListSidersPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_organisation_PatchRemunerationPolicySettingsPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const api_cmd_api_organisation_PatchRemunerationPolicySettingsResponseSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    additionalMention: z.string(),
    indemnities: z.array(z.string()).nullable(),
    ifmForSeasonal: z.boolean().nullish(),
    partTimeWorkEnabled: z.boolean(),
    cumulativeHourIncreasesEnabled: z.boolean(),
    lunchTicketSender: Services_charges_pkg_remunerationpolicy_LunchTicketSenderSchema.nullish(),
    unworkedPublicHolidaysHoursToPayCap: z.number().nullish(),
    createdAt: z.coerce.date().nullable(),
    updatedAt: z.coerce.date().nullable(),
});

export const api_cmd_api_organisation_ResetPaymentMethodPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const api_cmd_api_organisation_UploadHandlerPathparamsSchema = z.object({
    type: z.string(),
});

export const api_cmd_api_search_LogasQuerySchema = z.object({
    query: z.string().optional(),
});

export const api_cmd_api_task_CancelTaskPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_ClonePathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_ConfirmPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_DelPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_DeleteShiftPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_DeleteShiftQuerySchema = z.object({
    scope: z.string().optional(),
});

export const api_cmd_api_task_GetFlexiblePlanningPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_GetFlexiblePlanningQuotationPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_GetGuestTaskPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_GetGuestTaskQuerySchema = z.object({
    token: z.string().optional(),
});

export const api_cmd_api_task_GetPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_GetQuotationPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_GetShiftRecurrencePathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_ListApplicantsPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_PatchPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_PatchPlanningPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_PatchShiftPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_PatchShiftQuerySchema = z.object({
    scope: z.string().optional(),
});

export const api_cmd_api_task_PatchShiftsPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_PostFlexiblePlanningPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_PostFromJobDescriptionPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_PostShiftsPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_task_RunConfirmAutomationsPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_user_DeleteUserPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_user_PatchUserPathparamsSchema = z.object({
    id: z.string(),
});

export const api_cmd_api_user_ReInviteUserPathparamsSchema = z.object({
    id: z.string(),
});

export const api_pkg_attendance_dto_ActionTypeSchema = z.enum([
    "confirmation",
    "modification",
    "pending_validation",
    "refusal",
    "validation",
]);

export const api_pkg_attendance_dto_AttFeedbackSchema = z.object({
    id: z.string(),
    taskId: z.string(),
    siderId: z.string(),
    workAgain: z.int(),
    comment: z.string(),
});

export const api_pkg_attendance_dto_AttManagerSchema = z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
});

export const api_pkg_attendance_dto_AttSiderSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    pictureUrl: z.string().nullish(),
});

export const api_pkg_attendance_dto_AttTaskSchema = z.object({
    id: z.string(),
    name: z.string(),
    manager: api_pkg_attendance_dto_AttManagerSchema,
    jobTypeId: z.string(),
    isFlexiblePlanning: z.boolean(),
});

export const api_pkg_attendance_dto_AttendanceParamSchema = z.object({
    siderId: z.string().nullable(),
    startDate: z.string().nullable(),
    endDate: z.string().nullable(),
    breakDuration: z.string().nullable(),
    absenceJustification: Services_attendance_src_types_AbsenceJustificationSchema.nullish(),
});

export const api_pkg_attendance_dto_BreakSchema = z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
});

export const api_pkg_attendance_dto_DayIncludeSchema = z.object({
    holidays: z.boolean().nullish(),
    weekDays: z.boolean().nullish(),
    saturday: z.boolean().nullish(),
    sunday: z.boolean().nullish(),
});

export const api_pkg_attendance_dto_DeleteAttendanceErrorSchema = z.object({
    attendanceId: z.string(),
    error: z.string(),
});

export const api_pkg_attendance_dto_DeleteAttendancesReqSchema = z.object({
    attendanceIds: z.array(z.string()).nullable(),
});

export const api_pkg_attendance_dto_DeleteAttendancesRespSchema = z.object({
    errors: z.array(api_pkg_attendance_dto_DeleteAttendanceErrorSchema).nullable(),
});

export const api_pkg_attendance_dto_FormattedAttendanceDepartmentSchema = z.object({
    id: z.string(),
    name: z.string(),
});

export const api_pkg_attendance_dto_FormattedAttendanceFeedbackSchema = z.object({
    id: z.string(),
    attendanceId: z.string(),
    taskId: z.string(),
    siderId: z.string(),
    workAgain: z.int(),
    pro: z.int(),
    perf: z.int(),
    comment: z.string(),
});

export const api_pkg_attendance_dto_FormattedAttendanceFlexiblePlanningSchema = z.object({
    id: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    weeklyVolume: z.int(),
    siders: z.int(),
    amplitudeStart: z.string(),
    amplitudeEnd: z.string(),
    include: api_pkg_attendance_dto_DayIncludeSchema,
});

export const api_pkg_attendance_dto_FormattedAttendanceLocationSchema = z.object({
    id: z.string(),
    city: z.string(),
    country: z.string(),
    postalCode: z.string(),
    address: z.string(),
    lat: z.number(),
    lng: z.number(),
    description: z.string(),
});

export const api_pkg_attendance_dto_FormattedAttendanceShiftSchema = z.object({
    id: z.string(),
    taskId: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    breakDuration: z.int(),
    slots: z.int(),
    siderIds: z.array(z.string()).nullable(),
    missingSiderIds: z.array(z.string()).nullish(),
});

export const api_pkg_attendance_dto_FormattedAttendanceTaskSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    departmentId: z.string().nullish(),
    type: Services_task_shifts_pkg_task_TypeSchema,
    name: z.string(),
    orderReference: z.string().nullish(),
    jobTitle: z.string(),
    customJobTitle: z.string().nullish(),
    locationId: z.string(),
    managerId: z.string(),
    flexiblePlanningId: z.string().nullish(),
    origin: Services_task_shifts_pkg_task_OriginSchema,
});

export const api_pkg_attendance_dto_FormattedAttendanceUserSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    pictureUrl: z.string().nullish(),
    origin: Services_attendance_pkg_attendance_OriginSchema,
});

export const api_pkg_attendance_dto_HourlyVolumeScheduleKindSchema = z.object({
    tags: z.array(z.string()).nullable(),
    frequency: z.string(),
    duration: z.int(),
});

export const api_pkg_attendance_dto_HourlyVolumeSchema = z.object({
    enabled: z.boolean(),
    scheduleKinds: z.array(api_pkg_attendance_dto_HourlyVolumeScheduleKindSchema).nullable(),
});

export const api_pkg_attendance_dto_FormattedAttendanceOrganisationSchema = z.object({
    id: z.string(),
    name: z.string(),
    logoUrl: z.string(),
    hourlyVolume: api_pkg_attendance_dto_HourlyVolumeSchema.nullish(),
});

export const api_pkg_attendance_dto_OriginSchema = z.enum([
    "company",
    "shift",
    "insider",
    "sider",
    "system",
]);

export const api_pkg_attendance_dto_PostAttendanceDisputeSchema = z.object({
    companyId: z.string(),
    managerId: z.string(),
    shiftId: z.string(),
    siderId: z.string(),
    taskId: z.string(),
    bySider: z.boolean(),
    byCompany: z.boolean(),
    startDate: z.coerce.date().nullable(),
    endDate: z.coerce.date().nullable(),
    breakDates: z.array(Services_attendance_src_types_BreakDateSchema).nullable(),
    absenceJustification: Services_attendance_src_types_AbsenceJustificationSchema.nullish(),
});

export const api_pkg_attendance_dto_PostAttendancesParamsSchema = z.object({
    attendances: z.array(api_pkg_attendance_dto_AttendanceParamSchema).nullable(),
    partial: z.boolean().optional(),
});

export const api_pkg_attendance_dto_StatusSchema = z.enum([
    "att.conflict",
    "att.disputed",
    "att.missing",
    "att.validated",
    "att.waiting",
]);

export const api_pkg_attendance_dto_ListFormattedAttendancesParamsSchema = z.object({
    organisationIds: z.array(z.string()).nullish(),
    siderIds: z.array(z.string()).nullish(),
    taskIds: z.array(z.string()).nullish(),
    managerIds: z.array(z.string()).nullish(),
    statuses: z.array(api_pkg_attendance_dto_StatusSchema).nullish(),
    startDateAfter: z.coerce.date().nullish(),
    startDateBefore: z.coerce.date().nullish(),
});

export const api_pkg_attendance_dto_TypeSchema = z.enum(["conflicting", "matching"]);

export const api_pkg_attendance_dto_UpdatedBySchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
});

export const api_pkg_attendance_dto_ActionSchema = z.object({
    type: api_pkg_attendance_dto_ActionTypeSchema,
    origin: api_pkg_attendance_dto_OriginSchema.optional(),
    updatedBy: api_pkg_attendance_dto_UpdatedBySchema.nullable(),
    updatedAt: z.coerce.date(),
});

export const api_pkg_attendance_dto_ValidateAttendancesReqSchema = z.object({
    attendanceIds: z.array(z.string()).nullable(),
});

export const api_pkg_attendance_dto_ValidateAttendancesRespSchema = z.object({
    rejectedAttendanceIds: z.array(z.string()).nullable(),
});

export const api_pkg_attendance_dto_ValidationObjSchema = z.object({
    userId: z.string().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    origin: api_pkg_attendance_dto_OriginSchema,
    createdAt: z.coerce.date(),
});

export const api_pkg_attendance_dto_HistorySchema = z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    breaks: z.array(api_pkg_attendance_dto_BreakSchema).nullish(),
    origin: api_pkg_attendance_dto_OriginSchema.optional(),
    updatedBy: api_pkg_attendance_dto_UpdatedBySchema.nullish(),
    updatedAt: z.coerce.date(),
    actions: z.array(api_pkg_attendance_dto_ActionSchema).nullish(),
    absenceJustification: Services_attendance_src_types_AbsenceJustificationSchema.nullish(),
});

export const api_pkg_attendance_dto_AttendanceSchema = z.object({
    id: z.string(),
    shiftId: z.string(),
    task: api_pkg_attendance_dto_AttTaskSchema,
    sider: api_pkg_attendance_dto_AttSiderSchema,
    status: api_pkg_attendance_dto_StatusSchema,
    history: z.array(api_pkg_attendance_dto_HistorySchema).nullable(),
    feedback: api_pkg_attendance_dto_AttFeedbackSchema.nullish(),
    absenceJustification: Services_attendance_src_types_AbsenceJustificationSchema.nullish(),
});

export const api_pkg_auth_dto_ActivateUserReqSchema = z.object({
    password: z.string(),
    token: z.string(),
});

export const api_pkg_auth_dto_CreateAccountNeedSchema = z.enum([
    "learn-about-side",
    "less-than-7-days",
    "more-than-7-days",
]);

export const api_pkg_auth_dto_CreateAccountReqSchema = z.object({
    email: z.string(),
    password: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    phoneNumber: z.string(),
    companyName: z.string(),
    companySize: z.string(),
    need: api_pkg_auth_dto_CreateAccountNeedSchema,
    message: z.string(),
    needPermanentContract: z.boolean(),
    utm_campaign: z.string(),
    utm_medium: z.string(),
    utm_source: z.string(),
    googleLogin: z.boolean(),
});

export const api_pkg_auth_dto_GoogleActivateUserReqSchema = z.object({
    code: z.string(),
    token: z.string(),
});

export const api_pkg_auth_dto_GoogleLoginReqSchema = z.object({
    code: z.string(),
    platform: z.string().optional(),
});

export const api_pkg_auth_dto_GoogleSignUpReqSchema = z.object({
    code: z.string(),
});

export const api_pkg_auth_dto_LoginReqSchema = z.object({
    email: z.string(),
    password: z.string(),
});

export const api_pkg_auth_dto_LoginRespSchema = z.object({
    token: z.string(),
    email: z.string(),
    userId: z.string(),
    organisationId: z.string(),
    organisationType: z.string(),
    firstName: z.string(),
    lastName: z.string(),
});

export const api_pkg_auth_dto_SignUpReqSchema = z.object({
    email: z.string(),
});

export const api_pkg_auth_dto_SignUpRespSchema = z.object({
    email: z.string(),
});

export const api_pkg_contract_dto_ContestationSchema = z.object({
    name: z.string(),
    date: z.coerce.date(),
    reason: z.string(),
});

export const api_pkg_contract_dto_ListDocumentsReqSchema = z.object({
    signed: z.boolean().nullish(),
});

export const api_pkg_contract_dto_SignatureSchema = z.object({
    name: z.string(),
    date: z.coerce.date(),
    url: z.string(),
});

export const api_pkg_department_dto_DepartmentSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    name: z.string(),
    code: z.string().optional(),
    createdAt: z.coerce.date().nullish(),
    updatedAt: z.coerce.date().nullish(),
    deletedAt: z.coerce.date().nullish(),
});

export const api_cmd_api_department_GetResponseSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    name: z.string(),
    code: z.string().optional(),
    createdAt: z.coerce.date().nullish(),
    updatedAt: z.coerce.date().nullish(),
    deletedAt: z.coerce.date().nullish(),
});

export const api_cmd_api_department_PostResponseSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    name: z.string(),
    code: z.string().optional(),
    createdAt: z.coerce.date().nullish(),
    updatedAt: z.coerce.date().nullish(),
    deletedAt: z.coerce.date().nullish(),
});

export const api_pkg_department_dto_DepartmentsSchema = z
    .array(api_pkg_department_dto_DepartmentSchema)
    .nullable()
    .transform((val) => val ?? []);

export const api_pkg_department_dto_ListDepartmentsReqSchema = z.object({
    status: Services_companies_pkg_department_StatusSchema.nullish(),
});

export const api_pkg_department_dto_PostDepartmentReqSchema = z.object({
    organisationId: z.string(),
    name: z.string(),
    code: z.string().optional(),
});

export const api_pkg_jobdescription_dto_LocationSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    postalCode: z.string(),
    city: z.string(),
    lat: z.number(),
    lng: z.number(),
    country: z.string(),
    confirmed: z.boolean(),
    address: z.string(),
    description: z.string(),
    favorite: z.boolean(),
    title: z.string().nullish(),
    options: z.string(),
    vehicle: z.boolean(),
});

export const api_pkg_jobdescription_dto_OriginSchema = z.enum(["account", "network"]);

export const api_pkg_jobdescription_dto_PatchJobDescriptionUnsetSchema = z.object({
    location: z.boolean().nullish(),
    customJobTitleId: z.boolean().nullish(),
});

export const api_pkg_jobdescription_dto_PostJDEquipmentSchema = z.object({
    id: z.string().nullish(),
    group: z.string(),
    name: z.string(),
    providedBy: z.string(),
});

export const api_pkg_jobdescription_dto_PostJDSubtaskSchema = z.object({
    id: z.string().nullish(),
    name: z.string(),
});

export const api_pkg_jobdescription_dto_PostJDToolSchema = z.object({
    id: z.string().nullish(),
    name: z.string(),
});

export const api_pkg_jobdescription_dto_SimulationSchema = z.object({
    hourType: z.string(),
    coefficient: z.number(),
    hourlyRate: z.number(),
    increaseRate: z.number(),
    increase: z.number(),
});

export const api_pkg_jobdescription_dto_SimulationsSchema = z
    .array(api_pkg_jobdescription_dto_SimulationSchema)
    .nullable()
    .transform((val) => val ?? []);

export const api_pkg_jobdescription_dto_PricingSchema = z.object({
    id: z.string(),
    gestion: api_pkg_jobdescription_dto_SimulationsSchema,
    delegation: api_pkg_jobdescription_dto_SimulationsSchema,
});

export const api_pkg_legalvalue_dto_LegalValuesRespSchema = z.object({
    minimumSalary: z.number(),
});

export const api_pkg_organisation_dto_CompletionStepSchema = z.enum([
    "remunerationPolicy.hourTypes",
    "remunerationPolicy.indemnities",
    "legalInformations",
    "paymentInformations",
    "profile",
]);

export const api_pkg_organisation_dto_GetCompletionStatusRespSchema = z.object({
    complete: z.array(api_pkg_organisation_dto_CompletionStepSchema).nullable(),
    incomplete: z.array(api_pkg_organisation_dto_CompletionStepSchema).nullable(),
});

export const api_pkg_organisation_dto_GetOrganisationProfileRespSchema = z.object({
    name: z.string().optional(),
    description: z.string().optional(),
    website: z.string().optional(),
    logoURL: z.string().optional(),
    youtubeURL: z.string().optional(),
    coverURL: z.string().optional(),
});

export const api_pkg_organisation_dto_GetPaymentInformationsRespSchema = z.object({
    IBAN: z.string().optional(),
    clientSecret: z.string(),
    id: z.string().optional(),
    companyId: z.string().optional(),
    wantOrderForm: z.boolean().nullish(),
    billingAddress: Services_companies_models_api_BillingAddressSchema.optional(),
    tvaNumber: z.string().optional(),
    accountingInfo: Services_companies_models_api_AccountingInfoSchema.optional(),
    paymentMethod: Services_companies_models_api_PaymentMethodSchema.optional(),
    factored: z.boolean().optional(),
    paymentDelay: z.int(),
});

export const api_pkg_organisation_dto_HolidaySchema = z.object({
    name: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    solidarity: z.boolean(),
});

export const api_pkg_organisation_dto_ListHolidaysReqSchema = z.object({
    year: z.int(),
});

export const api_pkg_organisation_dto_ListHolidaysRespSchema = z.object({
    holidays: z.array(api_pkg_organisation_dto_HolidaySchema).nullable(),
});

export const api_pkg_organisation_dto_PatchOrganisationProfileReqSchema = z.object({
    name: z.string().nullish(),
    description: z.string().nullish(),
    website: z.string().nullish(),
    logoURL: z.string().nullish(),
    youtubeURL: z.string().nullish(),
    coverURL: z.string().nullish(),
});

export const api_pkg_organisation_dto_PatchRemunerationPolicyReqSchema = z.object({
    partTimeWorkEnabled: z.boolean().nullish(),
    cumulativeHourIncreasesEnabled: z.boolean().nullish(),
    lunchTicketSender: z.string().nullish(),
    unworkedPublicHolidaysHoursToPayCap: z.number().nullish(),
});

export const api_pkg_organisation_dto_PostSiderReqSchema = z.object({
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    phoneNumber: z.string().nullish(),
    email: z.string().nullish(),
});

export const api_pkg_organisation_dto_ProspectSiderProfileSchema = z.object({
    id: z.string(),
    positiveFeedbackRatio: z.int().nullish(),
    hiredCount: z.int(),
    hasProcessingDelay: z.boolean(),
});

export const api_pkg_organisation_dto_ListProspectSidersRespSchema = z.object({
    siders: z.array(api_pkg_organisation_dto_ProspectSiderProfileSchema).nullable(),
});

export const api_pkg_organisation_dto_SiderTypeSchema = z.enum(["delegation", "gestion"]);

export const api_pkg_organisation_dto_ListSidersReqSchema = z.object({
    recommended: z.boolean().nullish(),
    hiredAfter: z.coerce.date().nullish(),
    jobExp: z.boolean().nullish(),
    type: api_pkg_organisation_dto_SiderTypeSchema.optional(),
});

export const api_pkg_organisation_dto_UploadPictureRespSchema = z.object({
    URL: z.string(),
});

export const api_pkg_search_dto_SearchJobTitlesReqSchema = z.object({
    q: z.string(),
});

export const api_pkg_sider_dto_SiderProfileSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    pictureURL: z.string().nullable(),
});

export const api_pkg_task_dto_AssignmentSchema = z.object({
    name: z.string(),
    quantity: z.number(),
    hourlyRate: z.number(),
    price: z.number(),
    increase: z.number(),
    rate: z.number(),
    tags: z.array(z.string()).nullable(),
});

export const api_pkg_task_dto_AvailabilitiesSchema = z.object({
    startDate: z.coerce.date().nullish(),
    endDate: z.coerce.date().nullish(),
});

export const api_pkg_task_dto_CancelDetailSchema = z.object({
    reason: z.string().optional(),
    comment: z.string().optional(),
    isReplacement: z.boolean().optional(),
});

export const api_pkg_task_dto_CancelTaskReqSchema = z.object({
    category: z.string(),
    reason: z.string(),
    comment: z.string(),
});

export const api_pkg_task_dto_ConfirmTaskSchema = z.object({
    sideNote: z.string().nullish(),
    preSelection: z.boolean().nullish(),
    replaceSiderOnCancellation: z.boolean().nullish(),
    launchWithPrivateUntil: z.coerce.date().nullish(),
});

export const api_pkg_task_dto_DayIncludeSchema = z.object({
    holidays: z.boolean().nullish(),
    weekDays: z.boolean().nullish(),
    saturday: z.boolean().nullish(),
    sunday: z.boolean().nullish(),
});

export const api_pkg_task_dto_DeleteShiftsReqSchema = z.object({
    ids: z.array(z.string()).nullable(),
});

export const api_pkg_task_dto_EquipmentSchema = z.object({
    id: z.string(),
    group: z.string(),
    name: z.string(),
    providedBy: z.string(),
    custom: z.boolean(),
});

export const api_pkg_task_dto_GetFlexiblePlanningQuotationReqSchema = z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    weeklyVolume: z.int(),
    siders: z.int(),
    amplitudeStart: z.string(),
    amplitudeEnd: z.string(),
    include: api_pkg_task_dto_DayIncludeSchema,
});

export const api_pkg_task_dto_GetFlexiblePlanningQuotationRespSchema = z.object({
    salary: z.number(),
    price: z.number(),
    assignments: z.array(api_pkg_task_dto_AssignmentSchema).nullable(),
});

export const api_pkg_task_dto_GetFlexiblePlanningRespSchema = z.object({
    id: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    weeklyVolume: z.int(),
    siders: z.int(),
    amplitudeStart: z.string(),
    amplitudeEnd: z.string(),
    include: api_pkg_task_dto_DayIncludeSchema,
});

export const api_pkg_task_dto_GetQuotationRespSchema = z.object({
    salary: z.number(),
    price: z.number(),
    assignments: z.array(api_pkg_task_dto_AssignmentSchema).nullable(),
});

export const api_pkg_task_dto_GetShiftRecurrenceRespSchema = z.object({
    id: z.string(),
    type: z.string(),
    interval: z.int(),
    startDate: z.coerce.date(),
    until: z.coerce.date(),
    days: z.array(z.int()).nullable(),
    monthDays: z.array(z.int()).nullish(),
    setPos: z.array(z.int()).nullish(),
    withHolidays: z.boolean(),
});

export const api_pkg_task_dto_LanguageSchema = z.object({
    id: z.string(),
    ISOCode: z.string(),
    level: z.string(),
});

export const api_pkg_task_dto_LicenceSchema = z.object({
    id: z.string(),
    name: z.string(),
});

export const api_pkg_task_dto_ListApplicantsSchema = z.object({
    id: z.string(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    preSelectionStatus: Services_task_shifts_pkg_task_PreSelectionStatusSchema.nullish(),
    cvLink: z.string().nullish(),
    availabilities: api_pkg_task_dto_AvailabilitiesSchema.nullish(),
    visible: z.boolean().nullish(),
    comment: z.string().nullish(),
    refusalReason: z.string().nullish(),
});

export const api_cmd_api_task_ListApplicantsResponseSchema = z
    .array(api_pkg_task_dto_ListApplicantsSchema)
    .nullable()
    .transform((val) => val ?? []);

export const api_pkg_task_dto_ListHiredSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    pictureURL: z.string().optional(),
});

export const api_pkg_task_dto_GuestTaskSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    managerId: z.string(),
    name: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    hiredApplicantsToEvaluate: z.array(api_pkg_task_dto_ListHiredSchema).nullable(),
});

export const api_pkg_task_dto_ListTasksV2ReqSchema = z.object({
    hasShiftsAfter: z.coerce.date().optional(),
    hasShiftsBefore: z.coerce.date().optional(),
    organisationIds: z.array(z.string()).nullish(),
    siderIds: z.array(z.string()).nullish(),
});

export const api_pkg_task_dto_LocationSchema = z.object({
    id: z.string(),
    city: z.string(),
    country: z.string(),
    lat: z.number(),
    lng: z.number(),
    postalCode: z.string(),
    address: z.string(),
    description: z.string(),
    favorite: z.boolean(),
    motorized: z.boolean(),
    remote: z.boolean(),
    title: z.string().nullable(),
});

export const api_pkg_task_dto_ManagerSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
});

export const api_pkg_task_dto_ListEntitySchema = z.object({
    id: z.string(),
    startDate: z.coerce.date().nullish(),
    endDate: z.coerce.date().nullish(),
    name: z.string(),
    orderReference: z.string().nullish(),
    type: Services_task_shifts_pkg_task_TypeSchema,
    jobTitle: z.string().nullish(),
    status: z.string(),
    selectionStatus: z.string(),
    hiredSidersCount: z.int(),
    location: api_pkg_task_dto_LocationSchema.nullish(),
    manager: api_pkg_task_dto_ManagerSchema.nullish(),
    migrated: z.boolean(),
    preSelection: z.boolean().nullable(),
    origin: Services_task_shifts_pkg_task_OriginSchema,
});

export const api_pkg_task_dto_OperationSchema = z.enum(["cancel", "create", "edit"]);

export const api_pkg_task_dto_OperationErrorSchema = z.object({
    index: z.int(),
    shiftId: z.string(),
    error: z.string(),
});

export const api_pkg_task_dto_PatchSubtaskSchema = z.object({
    id: z.string().nullish(),
    name: z.string(),
});

export const api_pkg_task_dto_PatchTaskEquipmentSchema = z.object({
    id: z.string().nullish(),
    group: z.string(),
    name: z.string(),
    providedBy: z.string(),
});

export const api_pkg_task_dto_PatchTaskLocationSchema = z.object({
    id: z.string(),
    remote: z.boolean(),
    motorized: z.boolean(),
    postalCode: z.string(),
});

export const api_pkg_task_dto_PatchTaskToolSchema = z.object({
    id: z.string().nullish(),
    name: z.string(),
});

export const api_pkg_task_dto_PostFlexiblePlanningReqSchema = z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    weeklyVolume: z.int(),
    siders: z.int(),
    amplitudeStart: z.string(),
    amplitudeEnd: z.string(),
    include: api_pkg_task_dto_DayIncludeSchema,
});

export const api_pkg_task_dto_PostTaskReqSchema = z.object({
    type: Services_task_shifts_pkg_task_TypeSchema,
    name: z.string(),
    orderReference: z.string().nullish(),
    attendanceConfigType: Services_companies_pkg_attendanceconfig_TypeSchema.optional(),
});

export const api_pkg_task_dto_ProgressStepSchema = z.enum(["done", "draft", "ongoing", "upcoming"]);

export const api_pkg_task_dto_ListTasksReqSchema = z.object({
    limit: z.int().nullish(),
    offset: z.int().nullish(),
    managerId: z.string().nullish(),
    status: api_pkg_task_dto_ProgressStepSchema,
});

export const api_pkg_task_dto_ProspectSiderSchema = z.object({
    id: z.string(),
    positiveFeedbackRatio: z.int().optional(),
    hiredCount: z.int(),
});

export const api_pkg_task_dto_RecurrenceScopeTypeSchema = z.enum([
    "recurrence-all",
    "recurrence-following",
    "",
]);

export const api_pkg_task_dto_RequestedSiderSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    pictureURL: z.string().nullable(),
    status: z.string(),
});

export const api_pkg_task_dto_RiskSchema = z.object({
    id: z.string(),
    group: z.string(),
    name: z.string(),
    value: z.string().nullish(),
});

export const api_pkg_task_dto_ShiftSchema = z.object({
    id: z.string(),
    recurrenceId: z.string().nullish(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    breakDuration: z.int(),
    slots: z.int(),
    flexiblePlanningId: z.string().nullish(),
    hasHired: z.boolean().nullish(),
});

export const api_pkg_task_dto_PatchPlanningRespSchema = z.object({
    shifts: z.array(api_pkg_task_dto_ShiftSchema).nullable(),
    errors: z.array(api_pkg_task_dto_OperationErrorSchema).nullable(),
});

export const api_pkg_task_dto_PatchShiftEntitySchema = z.object({
    operation: api_pkg_task_dto_OperationSchema,
    category: z.string().optional(),
    id: z.string(),
    recurrenceId: z.string().nullish(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    breakDuration: z.int(),
    slots: z.int(),
    flexiblePlanningId: z.string().nullish(),
    hasHired: z.boolean().nullish(),
    reason: z.string().optional(),
    comment: z.string().optional(),
    isReplacement: z.boolean().optional(),
});

export const api_pkg_task_dto_PatchPlanningReqSchema = z
    .array(api_pkg_task_dto_PatchShiftEntitySchema)
    .nullable()
    .transform((val) => val ?? []);

export const api_pkg_task_dto_PostShiftReqSchema = z.object({
    id: z.string(),
    recurrenceId: z.string().nullish(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    breakDuration: z.int(),
    slots: z.int(),
    flexiblePlanningId: z.string().nullish(),
    hasHired: z.boolean().nullish(),
});

export const api_cmd_api_task_PatchShiftsRequestSchema = z
    .array(api_pkg_task_dto_PostShiftReqSchema)
    .nullable()
    .transform((val) => val ?? []);

export const api_pkg_task_dto_ShiftRecurrenceTypeSchema = z.enum(["monthly", "weekly"]);

export const api_pkg_task_dto_ShiftsRespSchema = z.object({
    shifts: z.array(api_pkg_task_dto_ShiftSchema).nullable(),
});

export const api_pkg_task_dto_SubtaskSchema = z.object({
    id: z.string(),
    name: z.string(),
});

export const api_pkg_task_dto_TaskV2DepartmentSchema = z.object({
    id: z.string(),
    name: z.string(),
});

export const api_pkg_task_dto_TaskV2FlexiblePlanningSchema = z.object({
    id: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    weeklyVolume: z.int(),
    siders: z.int(),
    amplitudeStart: z.string(),
    amplitudeEnd: z.string(),
    include: api_pkg_task_dto_DayIncludeSchema,
});

export const api_pkg_task_dto_TaskV2LocationSchema = z.object({
    id: z.string(),
    city: z.string(),
    country: z.string(),
    postalCode: z.string(),
    address: z.string(),
    lat: z.number(),
    lng: z.number(),
    description: z.string(),
});

export const api_pkg_task_dto_TaskV2OrganisationSchema = z.object({
    id: z.string(),
    name: z.string(),
    pictureUrl: z.string(),
});

export const api_pkg_task_dto_TaskV2SelectionStatusSchema = z.enum([
    "filled",
    "in_progress",
    "over",
    "planned",
]);

export const api_pkg_task_dto_TaskV2SelectionTargetSchema = z.enum([
    "delegation",
    "gestion",
    "work_again",
    "work_again_only",
]);

export const api_pkg_task_dto_TaskV2UserSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    pictureUrl: z.string(),
});

export const api_pkg_task_dto_TaskV2ShiftSchema = z.object({
    id: z.string(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    break: z.int(),
    slots: z.int(),
    siders: z.array(api_pkg_task_dto_TaskV2UserSchema).nullable(),
});

export const api_pkg_task_dto_TaskV2Schema = z.object({
    id: z.string(),
    organisation: api_pkg_task_dto_TaskV2OrganisationSchema,
    manager: api_pkg_task_dto_TaskV2UserSchema,
    department: api_pkg_task_dto_TaskV2DepartmentSchema.nullish(),
    postedBy: api_pkg_task_dto_TaskV2UserSchema,
    postedBySide: z.boolean(),
    postedAt: z.coerce.date(),
    jobTitle: z.string(),
    alias: z.string(),
    location: api_pkg_task_dto_TaskV2LocationSchema,
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    shifts: z.array(api_pkg_task_dto_TaskV2ShiftSchema).nullable(),
    flexiblePlanning: api_pkg_task_dto_TaskV2FlexiblePlanningSchema.nullish(),
    selectionStatus: api_pkg_task_dto_TaskV2SelectionStatusSchema,
    selectionTarget: api_pkg_task_dto_TaskV2SelectionTargetSchema,
    requestedSiders: z.array(api_pkg_task_dto_TaskV2UserSchema).nullable(),
    privateUntil: z.coerce.date().nullish(),
    applicantsCount: z.int(),
});

export const api_pkg_task_dto_ToolSchema = z.object({
    id: z.string(),
    name: z.string(),
    level: z.string().nullish(),
});

export const api_pkg_task_dto_WeekdaySchema = z.int();

export const api_pkg_task_dto_WeekdaysSchema = z
    .array(api_pkg_task_dto_WeekdaySchema)
    .nullable()
    .transform((val) => val ?? []);

export const api_pkg_task_dto_ShiftRecurrenceSchema = z.object({
    type: api_pkg_task_dto_ShiftRecurrenceTypeSchema,
    interval: z.int(),
    startDate: z.coerce.date(),
    until: z.coerce.date(),
    days: api_pkg_task_dto_WeekdaysSchema,
    monthDays: z.array(z.int()).nullable(),
    setPos: z.array(z.int()).nullable(),
    withHolidays: z.boolean(),
});

export const api_pkg_task_dto_PatchShiftReqSchema = z.object({
    startDate: z.coerce.date().nullish(),
    endDate: z.coerce.date().nullish(),
    breakDuration: z.int().nullish(),
    slots: z.int().nullish(),
    scope: api_pkg_task_dto_RecurrenceScopeTypeSchema.optional(),
    recurrence: api_pkg_task_dto_ShiftRecurrenceSchema.nullish(),
});

export const api_pkg_task_dto_PostShiftsReqSchema = z.object({
    recurrence: api_pkg_task_dto_ShiftRecurrenceSchema.nullish(),
    id: z.string(),
    recurrenceId: z.string().nullish(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    breakDuration: z.int(),
    slots: z.int(),
    flexiblePlanningId: z.string().nullish(),
    hasHired: z.boolean().nullish(),
});

export const api_pkg_user_dto_FormattedUserSourceOrganisationSchema = z.object({
    id: z.string(),
    name: z.string(),
});

export const api_pkg_user_dto_ListUsersReqSchema = z.object({
    withChildren: z.boolean(),
});

export const api_pkg_user_dto_PatchUserProfileReqSchema = z.object({
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    email: z.string().nullish(),
    phone: z.string().nullish(),
    password: z.string().nullish(),
    oldPassword: z.string().nullish(),
});

export const api_pkg_user_dto_PatchUserProfileRespSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    phone: z.string(),
});

export const charges_pkg_invoice_dto_PutInvoiceOrderFormMentionReqSchema = z.object({
    invoiceId: z.string(),
    orderFormMention: z.string(),
});

export const charges_pkg_pricing_dto_SimulationSchema = z.object({
    hourType: z.string(),
    coefficient: z.number(),
    osmoseCoefficient: z.number(),
    hourlyRate: z.number(),
    increaseRate: z.number(),
    tags: z.array(z.string()).nullable(),
});

export const api_pkg_task_dto_PricingSchema = z.object({
    gestion: z.array(charges_pkg_pricing_dto_SimulationSchema).nullish(),
    delegation: z.array(charges_pkg_pricing_dto_SimulationSchema).nullish(),
});

export const contract_v3_pkg_document_ContestationSchema = z.object({
    userId: z.string(),
    date: z.coerce.date(),
    reason: z.string().optional(),
});

export const contract_v3_pkg_document_StatusSchema = z.enum([
    "cancelled",
    "contested",
    "pending",
    "signed",
    "unsigned",
]);

export const api_pkg_contract_dto_ListDocumentsRespItemSchema = z.object({
    _id: z.string(),
    taskId: z.string(),
    taskName: z.string(),
    jobTypeId: z.string(),
    organisationId: z.string(),
    organisationName: z.string(),
    managerName: z.string(),
    contractIds: z.array(z.string()).nullable(),
    startDate: z.coerce.date(),
    status: contract_v3_pkg_document_StatusSchema,
    url: z.string(),
    signature: api_pkg_contract_dto_SignatureSchema.nullish(),
    contestation: api_pkg_contract_dto_ContestationSchema.nullish(),
});

export const api_pkg_contract_dto_ListDocumentsRespSchema = z.object({
    documents: z.array(api_pkg_contract_dto_ListDocumentsRespItemSchema).nullable(),
    offset: z.int(),
    limit: z.int(),
    total: z.int(),
});

export const contract_v3_pkg_document_TypeSchema = z.enum([
    "CET",
    "company",
    "less-than-24h",
    "sider",
]);

export const errorSchema = z.unknown();

export const Services_team_api_dto_PatchPaymentInformationsSchema = z.object({
    stripeToken: z.any().nullish(),
    wantOrderForm: z.boolean().nullish(),
    billingAddress: Services_team_api_dto_BillingAddressSchema.optional(),
    tvaNumber: z.string().optional(),
    accountingInfo: Services_team_api_dto_AccountingInfoSchema.optional(),
});

export const api_pkg_attendance_dto_ListFormattedAttendancesRespSchema = z.object({
    attendances: z.array(Services_attendance_pkg_attendance_FormattedAttendanceSchema).nullable(),
    users: z.array(api_pkg_attendance_dto_FormattedAttendanceUserSchema).nullable(),
    tasks: z.array(api_pkg_attendance_dto_FormattedAttendanceTaskSchema).nullable(),
    shifts: z.array(api_pkg_attendance_dto_FormattedAttendanceShiftSchema).nullable(),
    organisations: z.array(api_pkg_attendance_dto_FormattedAttendanceOrganisationSchema).nullable(),
    departments: z.array(api_pkg_attendance_dto_FormattedAttendanceDepartmentSchema).nullable(),
    locations: z.array(api_pkg_attendance_dto_FormattedAttendanceLocationSchema).nullable(),
    flexiblePlannings: z
        .array(api_pkg_attendance_dto_FormattedAttendanceFlexiblePlanningSchema)
        .nullable(),
    feedbacks: z.array(api_pkg_attendance_dto_FormattedAttendanceFeedbackSchema).nullable(),
    isDataPartial: z.boolean(),
});

export const api_pkg_task_dto_ListTasksV2RespSchema = z.object({
    tasks: z.array(api_pkg_task_dto_TaskV2Schema).nullable(),
    isDataPartial: z.boolean(),
});

export const gitlab_side_co_pkg_sidehttp_v8_PaginationSchema = z.object({
    offset: z.int(),
    limit: z.int(),
    total: z.int(),
});

export const api_pkg_attendance_dto_GetAttendanceParamsSchema = z.object({
    siderId: z.string().nullable(),
    managerId: z.string().nullable(),
    status: z.array(api_pkg_attendance_dto_StatusSchema).nullable(),
    type: z.array(api_pkg_attendance_dto_TypeSchema).nullable(),
    startDate: z.coerce.date().nullable(),
    endDate: z.coerce.date().nullable(),
    offset: z.int(),
    limit: z.int(),
    total: z.int(),
});

export const api_pkg_attendance_dto_GetAttendanceRespSchema = z.object({
    attendances: z.array(api_pkg_attendance_dto_AttendanceSchema).nullable(),
    hourlyVolume: api_pkg_attendance_dto_HourlyVolumeSchema.nullish(),
    offset: z.int(),
    limit: z.int(),
    total: z.int(),
});

export const api_pkg_sider_dto_ListSidersReqSchema = z.object({
    search: z.string().nullable(),
    offset: z.int(),
    limit: z.int(),
    total: z.int(),
});

export const api_pkg_sider_dto_ListSidersRespSchema = z.object({
    siders: z.array(api_pkg_sider_dto_SiderProfileSchema).nullable(),
    offset: z.int(),
    limit: z.int(),
    total: z.int(),
});

export const api_pkg_task_dto_ListRespSchema = z.object({
    tasks: z.array(api_pkg_task_dto_ListEntitySchema).nullable(),
    offset: z.int(),
    limit: z.int(),
    total: z.int(),
});

export const gitlab_side_co_pkg_sides3proxy_DownloadHandlerPathparamsSchema = z.object({
    type: z.string(),
    id: z.string(),
});

export const gitlab_side_co_pkg_sides3proxy_UploadHandlerPathparamsSchema = z.object({
    type: z.string(),
    id: z.string(),
});

export const inside_api_pkg_companies_dto_OriginSchema = z.enum([
    "default",
    "detached",
    "parent",
    "undefined",
]);

export const lego_pkg_client_dto_CustomJobTitleSchema = z.object({
    id: z.string(),
    name: z.string(),
});

export const lego_pkg_client_dto_EquipmentSchema = z.object({
    providedBy: z.string(),
    id: z.string(),
    group: z.string(),
    name: z.string(),
    custom: z.boolean(),
});

export const lego_pkg_client_dto_ExecutiveStatusSchema = z.enum(["ETAM", "executive", "worker"]);

export const lego_pkg_client_dto_JobTitleSchema = z.object({
    id: z.string(),
    name: z.string(),
});

export const lego_pkg_client_dto_MobilitySchema = z.object({
    mobilityZone: z.string(),
    drivesCompanyVehicle: z.boolean().nullish(),
});

export const api_pkg_jobdescription_dto_JobDescriptionsDetailsSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    managerId: z.string().nullish(),
    jobTitle: lego_pkg_client_dto_JobTitleSchema.nullish(),
    customJobTitle: lego_pkg_client_dto_CustomJobTitleSchema.nullish(),
    suffix: z.string().nullish(),
    enabled: z.boolean(),
    hourlyRate: z.number().nullable(),
    origin: api_pkg_jobdescription_dto_OriginSchema,
    executiveStatus: lego_pkg_client_dto_ExecutiveStatusSchema,
    mobility: lego_pkg_client_dto_MobilitySchema.nullish(),
    subtasks: Services_lego_pkg_subtask_SsSchema.optional(),
    equipment: z.array(lego_pkg_client_dto_EquipmentSchema).nullish(),
    risks: Services_lego_pkg_risk_RsSchema.optional(),
    languages: Services_lego_pkg_language_LsSchema.optional(),
    tools: Services_lego_pkg_tool_TsSchema.optional(),
    licences: Services_lego_pkg_licence_LsSchema.optional(),
    location: api_pkg_jobdescription_dto_LocationSchema.nullish(),
    purpose: z.string().nullish(),
    dressCode: z.string().nullish(),
    workConditions: z.string().nullish(),
    experiences: z.string().nullish(),
    pricing: api_pkg_jobdescription_dto_PricingSchema.nullish(),
    pricingOrigin: inside_api_pkg_companies_dto_OriginSchema.optional(),
    preSelection: z.boolean().nullish(),
    hasHighRiskPosition: z.boolean().nullish(),
    replaceSiderOnCancellation: z.boolean().nullish(),
    createdAt: z.coerce.date().nullish(),
    updatedAt: z.coerce.date().nullish(),
});

export const api_pkg_jobdescription_dto_ListJobDescriptionsDetailsRespSchema = z
    .array(api_pkg_jobdescription_dto_JobDescriptionsDetailsSchema)
    .nullable()
    .transform((val) => val ?? []);

export const api_pkg_jobdescription_dto_PostJobDescriptionReqSchema = z.object({
    managerId: z.string().nullish(),
    jobTitleId: z.string().nullish(),
    customJobTitleId: z.string().nullish(),
    suffix: z.string().nullish(),
    enabled: z.boolean().nullish(),
    hourlyRate: z.number().nullish(),
    executiveStatus: lego_pkg_client_dto_ExecutiveStatusSchema.nullish(),
    mobility: lego_pkg_client_dto_MobilitySchema.nullish(),
    subtasks: z.array(api_pkg_jobdescription_dto_PostJDSubtaskSchema).nullish(),
    equipment: z.array(api_pkg_jobdescription_dto_PostJDEquipmentSchema).nullish(),
    riskIds: z.array(z.string()).nullish(),
    languageIds: z.array(z.string()).nullish(),
    tools: z.array(api_pkg_jobdescription_dto_PostJDToolSchema).nullish(),
    licenceIds: z.array(z.string()).nullish(),
    location: api_pkg_jobdescription_dto_LocationSchema.nullish(),
    purpose: z.string().nullish(),
    dressCode: z.string().nullish(),
    workConditions: z.string().nullish(),
    experiences: z.string().nullish(),
    preSelection: z.boolean().nullish(),
    hasHighRiskPosition: z.boolean().nullish(),
    replaceSiderOnCancellation: z.boolean().nullish(),
    pricingId: z.string().nullish(),
});

export const api_pkg_jobdescription_dto_PatchJobDescriptionReqSchema = z.object({
    unset: api_pkg_jobdescription_dto_PatchJobDescriptionUnsetSchema.nullish(),
    managerId: z.string().nullish(),
    jobTitleId: z.string().nullish(),
    customJobTitleId: z.string().nullish(),
    suffix: z.string().nullish(),
    enabled: z.boolean().nullish(),
    hourlyRate: z.number().nullish(),
    executiveStatus: lego_pkg_client_dto_ExecutiveStatusSchema.nullish(),
    mobility: lego_pkg_client_dto_MobilitySchema.nullish(),
    subtasks: z.array(api_pkg_jobdescription_dto_PostJDSubtaskSchema).nullish(),
    equipment: z.array(api_pkg_jobdescription_dto_PostJDEquipmentSchema).nullish(),
    riskIds: z.array(z.string()).nullish(),
    languageIds: z.array(z.string()).nullish(),
    tools: z.array(api_pkg_jobdescription_dto_PostJDToolSchema).nullish(),
    licenceIds: z.array(z.string()).nullish(),
    location: api_pkg_jobdescription_dto_LocationSchema.nullish(),
    purpose: z.string().nullish(),
    dressCode: z.string().nullish(),
    workConditions: z.string().nullish(),
    experiences: z.string().nullish(),
    preSelection: z.boolean().nullish(),
    hasHighRiskPosition: z.boolean().nullish(),
    replaceSiderOnCancellation: z.boolean().nullish(),
    pricingId: z.string().nullish(),
});

export const lego_pkg_motives_dto_ListMotivesRespSchema = z.object({
    motives: z.array(Services_lego_pkg_motives_MSchema).nullable(),
});

export const api_cmd_api_motive_ListMotivesResponseSchema = z.object({
    motives: z.array(Services_lego_pkg_motives_MSchema).nullable(),
});

export const locations_pkg_location_dto_ListLocationsRespSchema = z.object({
    locations: z.array(Services_locations_pkg_location_LSchema).nullable(),
});

export const organisation_pkg_organisation_dto_RoleSchema = z.enum([
    "admin",
    "collaborator",
    "missionManager",
]);

export const api_pkg_user_dto_FormattedUserSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    role: organisation_pkg_organisation_dto_RoleSchema,
    validated: z.boolean(),
    sourceOrganisation: api_pkg_user_dto_FormattedUserSourceOrganisationSchema.nullish(),
});

export const api_pkg_user_dto_ListUsersRespSchema = z.object({
    users: z.array(api_pkg_user_dto_FormattedUserSchema).nullable(),
});

export const api_pkg_user_dto_PatchUserReqSchema = z.object({
    role: organisation_pkg_organisation_dto_RoleSchema.nullish(),
});

export const api_pkg_user_dto_PostUserReqSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    role: organisation_pkg_organisation_dto_RoleSchema,
});

export const seshat_pkg_elastic_dto_JobTitleSchema = z.object({
    id: z.string(),
    name: z.string(),
    romeCodeName: z.string(),
    romeCodeId: z.string(),
    industry: z.string(),
    available: z.boolean().nullish(),
    blocked: z.boolean().nullish(),
});

export const api_cmd_api_search_SearchJobTitlesResponseSchema = z
    .array(seshat_pkg_elastic_dto_JobTitleSchema)
    .nullable()
    .transform((val) => val ?? []);

export const task_shifts_pkg_task_dto_UpdateTaskApplicantInsertSchema = z.object({
    statusHistory: Services_task_shifts_pkg_task_ApplicantStatusHistorySchema.nullish(),
    cancelledStatusHistory: Services_task_shifts_pkg_task_ApplicantStatusHistorySchema.nullish(),
});

export const task_shifts_pkg_task_dto_UpdateTaskApplicantUpdateSchema = z.object({
    notified: z.boolean().nullish(),
    status: z.string().nullish(),
    reason: z.string().nullish(),
    lastStatusNotified: z.string().nullish(),
    lastStatusNotifiedDate: z.coerce.date().nullish(),
    preSelectionStatus: Services_task_shifts_pkg_task_PreSelectionStatusSchema.nullish(),
    visible: z.boolean().nullish(),
    comment: z.string().nullish(),
    refusalReason: z.string().nullish(),
    cvLink: z.string().nullish(),
});

export const task_shifts_pkg_task_dto_UpdateTaskApplicantSchema = z.object({
    id: z.string().nullish(),
    update: task_shifts_pkg_task_dto_UpdateTaskApplicantUpdateSchema,
    insert: task_shifts_pkg_task_dto_UpdateTaskApplicantInsertSchema,
});

export const task_shifts_pkg_task_dto_WeekCycleSchema = z.object({
    name: z.string(),
    description: z.string().optional(),
    code: z.string(),
});

export const api_pkg_task_dto_PatchTaskReqSchema = z.object({
    name: z.string().nullable(),
    type: Services_task_shifts_pkg_task_TypeSchema.nullish(),
    managerId: z.string().nullable(),
    departmentId: z.string().nullable(),
    motive: Services_task_shifts_pkg_task_MotiveSchema.nullish(),
    motiveId: z.string().nullish(),
    location: api_pkg_task_dto_PatchTaskLocationSchema.nullable(),
    requestedSiderIds: z.array(z.string()).nullable(),
    requestedSidersOnly: z.boolean().nullable(),
    prospectSiderIds: z.array(z.string()).nullable(),
    hourlyRate: z.number().nullable(),
    missionInformation: z.string().nullable(),
    flexiblePlanning: z.boolean().nullable(),
    flexiblePlanningId: z.string().nullable(),
    applicant: task_shifts_pkg_task_dto_UpdateTaskApplicantSchema.optional(),
    sideNote: z.string().nullable(),
    dressCode: z.string().nullish(),
    addressDetails: z.string().nullish(),
    purpose: z.string().nullish(),
    experiences: z.string().nullish(),
    equipments: z.array(api_pkg_task_dto_PatchTaskEquipmentSchema).nullable(),
    languageIds: z.array(z.string()).nullable(),
    tools: z.array(api_pkg_task_dto_PatchTaskToolSchema).nullable(),
    licenceIds: z.array(z.string()).nullable(),
    subtasks: z.array(api_pkg_task_dto_PatchSubtaskSchema).nullable(),
    riskIds: z.array(z.string()).nullable(),
    weekCycles: z.array(task_shifts_pkg_task_dto_WeekCycleSchema).nullish(),
    workConditions: z.string().nullish(),
    executiveStatus: lego_pkg_client_dto_ExecutiveStatusSchema.nullish(),
    mobility: lego_pkg_client_dto_MobilitySchema.nullish(),
    replaceSiderOnCancellation: z.boolean().nullish(),
});

export const api_pkg_task_dto_TSchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    departmentId: z.string().nullish(),
    type: Services_task_shifts_pkg_task_TypeSchema,
    name: z.string(),
    orderReference: z.string().nullish(),
    jobTitle: z.string().optional(),
    customJobTitle: z.string().nullish(),
    status: Services_task_shifts_pkg_task_StatusSchema,
    progressStep: api_pkg_task_dto_ProgressStepSchema,
    requestedSiders: z.array(api_pkg_task_dto_RequestedSiderSchema).nullish(),
    requestedSidersOnly: z.boolean(),
    prospectSiders: z.array(api_pkg_task_dto_ProspectSiderSchema).nullish(),
    selectionStatus: z.string(),
    executiveStatus: lego_pkg_client_dto_ExecutiveStatusSchema,
    mobility: lego_pkg_client_dto_MobilitySchema.nullish(),
    pricing: api_pkg_task_dto_PricingSchema,
    hourlyRate: z.number().optional(),
    comRate: z.number(),
    location: api_pkg_task_dto_LocationSchema.nullish(),
    manager: api_pkg_task_dto_ManagerSchema.nullish(),
    missionInformation: z.string().nullish(),
    motive: Services_task_shifts_pkg_task_MotiveSchema.nullish(),
    motiveId: z.string().nullish(),
    shifts: z.array(api_pkg_task_dto_ShiftSchema).nullish(),
    subtasks: z.array(api_pkg_task_dto_SubtaskSchema).nullish(),
    equipments: z.array(api_pkg_task_dto_EquipmentSchema).nullish(),
    weekCycles: z.array(task_shifts_pkg_task_dto_WeekCycleSchema).nullish(),
    risks: z.array(api_pkg_task_dto_RiskSchema).nullish(),
    languages: z.array(api_pkg_task_dto_LanguageSchema).nullish(),
    tools: z.array(api_pkg_task_dto_ToolSchema).nullish(),
    licences: z.array(api_pkg_task_dto_LicenceSchema).nullish(),
    sideNote: z.string().nullish(),
    purpose: z.string().nullish(),
    dressCode: z.string().nullish(),
    workConditions: z.string().nullish(),
    experiences: z.string().nullish(),
    migrated: z.boolean(),
    preSelection: z.boolean().nullish(),
    flexiblePlanning: z.boolean().nullish(),
    flexiblePlanningId: z.string().nullish(),
    hasContracts: z.boolean(),
    replaceSiderOnCancellation: z.boolean().nullish(),
    origin: Services_task_shifts_pkg_task_OriginSchema,
});

export const team_api_controllers_attendances_GetAttendanceDisputePathparamsSchema = z.object({
    attendanceID: z.string(),
    disputeID: z.string(),
});

export const team_api_controllers_attendances_GetAttendancesToValidateCountResponseSchema =
    z.partialRecord(z.string(), z.int());

export const team_api_controllers_attendances_PostAttendanceReviewPathparamsSchema = z.object({
    attendanceID: z.string(),
});

export const team_api_controllers_attendances_PutAttendanceDisputePathparamsSchema = z.object({
    attendanceID: z.string(),
    disputeID: z.string(),
});

export const team_api_controllers_contract_ContestDocumentPathparamsSchema = z.object({
    organisationId: z.string(),
    documentId: z.string(),
});

export const team_api_controllers_contract_GetCountUnsignedDocumentsByOrganisationPathparamsSchema =
    z.object({
        organisationId: z.string(),
    });

export const team_api_controllers_contract_ListDocumentsPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_contract_RegenerateDocumentsPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_contract_SetFixedWeeklyDurationPathparamsSchema = z.object({
    contractId: z.string(),
});

export const team_api_controllers_contract_SignDocumentPathparamsSchema = z.object({
    organisationId: z.string(),
    documentId: z.string(),
});

export const team_api_controllers_feedback_GetFeedbackPathparamsSchema = z.object({
    feedbackId: z.string(),
});

export const team_api_controllers_feedback_PostFeedbackPathparamsSchema = z.object({
    organisationId: z.string(),
    siderId: z.string(),
});

export const team_api_controllers_feedback_PostFeedbackResponseSchema = z.string();

export const team_api_controllers_feedback_PostGuestFeedbackQuerySchema = z.object({
    token: z.string().optional(),
});

export const team_api_controllers_feedback_PostGuestFeedbackResponseSchema = z.string();

export const team_api_controllers_feedback_UpdateFeedbackPathparamsSchema = z.object({
    feedbackId: z.string(),
});

export const team_api_controllers_feedback_UpdateFeedbackResponseSchema = z.string();

export const team_api_controllers_invoice_DownloadInvoicesPathparamsSchema = z.object({
    service: z.string(),
});

export const team_api_controllers_invoice_DownloadInvoicesQuerySchema = z.object({
    startDate: z.string().optional(),
    endDate: z.string().optional(),
});

export const team_api_controllers_invoice_GetOrganisationInvoicesQuerySchema = z.object({
    startDate: z.string().optional(),
    endDate: z.string().optional(),
});

export const team_api_controllers_invoice_GetOrganisationInvoicesResponseSchema = z.object({
    firstPaymentDate: z.coerce.date(),
    invoices: z.array(z.unknown()).nullable(),
});

export const team_api_controllers_jobtypes_ListPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_organisations_GetChildrenPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_organisations_GetChildrenResponseSchema = z.partialRecord(
    z.string(),
    z.unknown(),
);

export const team_api_controllers_organisations_GetLegalInformationsPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_organisations_GetLegalInformationsResponseSchema = z.object({
    name: z.string(),
    businessName: z.string(),
    siret: z.string(),
    apeCode: z.string(),
});

export const team_api_controllers_organisations_GetOrganisationInvoicesQuerySchema = z.object({
    startDate: z.string().optional(),
    endDate: z.string().optional(),
});

export const team_api_controllers_organisations_ListLocationsPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_organisations_PatchLegalInformationsPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_organisations_PatchLocationPathparamsSchema = z.object({
    organisationId: z.string(),
    locationId: z.string(),
});

export const team_api_controllers_organisations_PatchPaymentInformationsSchema = z.object({
    paymentMethodId: z.string(),
    sourceId: z.string(),
    paymentMethodType: z.string(),
    IBAN: z.string().optional(),
    stripeToken: z.any().nullish(),
    wantOrderForm: z.boolean().nullish(),
    billingAddress: Services_team_api_dto_BillingAddressSchema.optional(),
    tvaNumber: z.string().optional(),
    accountingInfo: Services_team_api_dto_AccountingInfoSchema.optional(),
});

export const team_api_controllers_organisations_PatchPaymentInformationsPathparamsSchema = z.object(
    {
        organisationId: z.string(),
    },
);

export const team_api_controllers_organisations_PostLocationPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_remuneration_ConfirmHourTypesPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_remuneration_ConfirmIndemnitiesPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_remuneration_GetRemunerationPolicyPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_remuneration_PatchHourTypesPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_remuneration_PatchIndemnitiesPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_controllers_siders_GetSiderPathparamsSchema = z.object({
    siderId: z.string(),
});

export const team_api_controllers_tasks_ListTasksNamesPathparamsSchema = z.object({
    organisationId: z.string(),
});

export const team_api_repositories_organisations_AddressSchema = z.object({
    country: z.string(),
    street: z.string(),
    postalCode: z.string(),
    city: z.string(),
});

export const team_api_repositories_organisations_ConventionConfirmationSchema = z.object({
    date: z.coerce.date().nullable(),
    userId: z.string(),
});

export const team_api_repositories_organisations_InvoiceInfosSchema = z.object({
    businessName: z.string().nullable(),
    address: team_api_repositories_organisations_AddressSchema,
});

export const team_api_repositories_organisations_UsersRegistryTypeSchema = z.object({
    id: z.string(),
    status: z.string(),
    index: z.int(),
    roles: z.array(z.string()).nullable(),
    features: z.array(z.string()).nullish(),
});

export const team_api_repositories_organisations_OrganisationSchema = z.object({
    id: z.string(),
    name: z.string(),
    apeCode: z.string(),
    siret: z.string(),
    invoiceInfos: team_api_repositories_organisations_InvoiceInfosSchema,
    hoursTypesConfirmation:
        team_api_repositories_organisations_ConventionConfirmationSchema.nullish(),
    indemnitiesConfirmation:
        team_api_repositories_organisations_ConventionConfirmationSchema.nullish(),
    users: z.array(team_api_repositories_organisations_UsersRegistryTypeSchema).nullable(),
    workLegalStatus: z.string(),
    logoUrl: z.string(),
    features: z.array(z.string()).nullish(),
    organisationType: z.string().nullish(),
    parentOrganisationIds: z.array(z.string()).nullish(),
    industry: z.string().nullish(),
    attendanceConfigType: Services_companies_pkg_attendanceconfig_TypeSchema.optional(),
    attendanceAutoValidation: z.boolean().nullish(),
    interestedOfferTypes: z.array(z.string()).nullish(),
});

export const team_api_src_types_AttendanceReviewBodySchema = z.object({
    attendanceId: z.string(),
    siderId: z.string(),
    reviewed: z.boolean(),
});

export const team_api_src_types_BreakDatesSchema = z.object({
    startDate: z.coerce.date().nullable(),
    endDate: z.coerce.date().nullable(),
});

export const team_api_src_types_DisputeHistorySchema = z.object({
    managerId: z.string(),
    bySider: z.boolean(),
    byCompany: z.boolean(),
    startDate: z.coerce.date().nullable(),
    endDate: z.coerce.date().nullable(),
    breakDates: z.array(team_api_src_types_BreakDatesSchema).nullable(),
    absenceJustification: Services_attendance_src_types_AbsenceJustificationSchema.nullish(),
    createdAt: z.coerce.date().nullable(),
});

export const team_api_src_types_DisputeSchema = z.object({
    _id: z.string(),
    attendanceId: z.string(),
    companyId: z.string(),
    managerId: z.string(),
    shiftId: z.string(),
    siderId: z.string(),
    taskId: z.string(),
    bySider: z.boolean(),
    byCompany: z.boolean(),
    disputeIsOver: z.boolean(),
    startDate: z.coerce.date().nullable(),
    endDate: z.coerce.date().nullable(),
    breakDates: z.array(team_api_src_types_BreakDatesSchema).nullable(),
    disputeHistory: z.array(team_api_src_types_DisputeHistorySchema).nullable(),
    absenceJustification: Services_attendance_src_types_AbsenceJustificationSchema.nullish(),
    createdAt: z.coerce.date().nullable(),
    updatedAt: z.coerce.date().nullable(),
});

export const team_api_src_types_FeedbackBodySchema = z.object({
    taskId: z.string(),
    organisationId: z.string(),
    logasId: z.string(),
    typeId: z.string().optional(),
    managerId: z.string(),
    siderId: z.string(),
    comment: z.string(),
    pro: z.int(),
    perf: z.int(),
});

export const team_api_src_types_FeedbackBodyUpdateSchema = z.object({
    _id: z.string(),
    taskId: z.string(),
    organisationId: z.string(),
    typeId: z.string().optional(),
    managerId: z.string(),
    siderId: z.string(),
    comment: z.string(),
    pro: z.int(),
    perf: z.int(),
});

export const team_api_src_types_InvoiceSchema = z.object({
    taskName: z.string(),
    siderName: z.string(),
    paid: z.boolean(),
    sideInvoiceUrl: z.string().optional(),
    currency: z.string(),
    amount: z.number(),
    createdAt: z.coerce.date(),
});

export const team_api_src_types_InvoiceListSchema = z.object({
    firstPaymentDate: z.coerce.date(),
    invoices: z.array(team_api_src_types_InvoiceSchema).nullable(),
});

export const team_api_src_types_OrganisationShortSchema = z.object({
    id: z.string(),
    name: z.string(),
    logoUrl: z.string(),
    interestedOfferTypes: z.array(z.string()).nullable(),
});

export const team_api_src_types_OrganisationUserSchema = z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    phoneNumber: z.string(),
});

export const api_pkg_organisation_dto_GetOrganisationRespSchema = z.object({
    members: z.array(team_api_src_types_OrganisationUserSchema).nullable(),
    organisation: team_api_repositories_organisations_OrganisationSchema.nullish(),
    children: z.array(Services_organisation_pkg_organisation_OSchema).nullish(),
    parent: z.string().optional(),
});

export const team_api_src_types_PutDisputeBodySchema = z.object({
    _id: z.string(),
    managerId: z.string(),
    bySider: z.boolean(),
    byCompany: z.boolean(),
    startDate: z.coerce.date().nullish(),
    endDate: z.coerce.date().nullish(),
    breakDates: z.array(team_api_src_types_BreakDatesSchema).nullish(),
});

export const team_api_src_types_UserMeSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    organisation: team_api_src_types_OrganisationShortSchema.nullable(),
    hasConversationNotification: z.boolean(),
    pendingInvoiceNumber: z.int(),
    isAdmin: z.boolean(),
    isInsider: z.boolean(),
    role: z.string(),
    email: z.string(),
    phoneNumber: z.string(),
    lookerURL: z.string().optional(),
    passwordLastModified: z.coerce.date().nullish(),
});

export const team_api_src_types_UserUpdateBodySchema = z.object({
    Locale: z.string(),
});

export const v3_pkg_contract_dto_SetFixedWeeklyDurationReqSchema = z.object({
    weeklyDuration: z.int().nullable(),
});

export const v3_pkg_contract_dto_WaitingPeriodEndDateSchema = z.object({
    endDate: z.coerce.date(),
    contractId: z.string(),
    contractNumber: z.int(),
});

export const api_pkg_organisation_dto_SiderSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    pictureUrl: z.string().nullable(),
    phoneNumber: z.string(),
    lastOrganisationName: z.string(),
    source: z.string(),
    lastWorkedDate: z.coerce.date().nullable(),
    isRecommended: z.boolean(),
    recommendationReason: z.string().optional(),
    hasProcessingDelay: z.boolean(),
    waitingPeriodEndDate: v3_pkg_contract_dto_WaitingPeriodEndDateSchema.nullish(),
});

export const api_pkg_organisation_dto_ListSidersRespSchema = z.object({
    siders: z.array(api_pkg_organisation_dto_SiderSchema).nullable(),
});

export const v3_pkg_document_dto_ContestReqSchema = z.object({
    managerId: z.string(),
    description: z.string(),
});

export const v3_pkg_document_dto_ContestRespSchema = z.object({
    id: z.string(),
    status: contract_v3_pkg_document_StatusSchema,
    contestation: contract_v3_pkg_document_ContestationSchema,
});

export const v3_pkg_document_dto_CountRespSchema = z.object({
    count: z.int(),
});

export const v3_pkg_document_dto_ListReqSchema = z.object({
    ids: z.array(z.string()).nullish(),
    companyId: z.string().nullish(),
    companyIds: z.array(z.string()).nullish(),
    contractId: z.string().nullish(),
    contractIds: z.array(z.string()).nullish(),
    statuses: z.array(contract_v3_pkg_document_StatusSchema).nullish(),
    type: contract_v3_pkg_document_TypeSchema.nullish(),
    signed: z.boolean().nullish(),
    cancelled: z.boolean().nullish(),
    managerId: z.string().nullish(),
    offset: z.int(),
    limit: z.int(),
    createdAfter: z.coerce.date().nullish(),
    createdBefore: z.coerce.date().nullish(),
    updatedAfter: z.coerce.date().nullish(),
    updatedBefore: z.coerce.date().nullish(),
});

export const vmx_pkg_vmsconfiguration_dto_WeekCycleSchema = z.object({
    name: z.string(),
    description: z.string().optional(),
    code: z.string(),
});

export const vmx_pkg_vmsconfiguration_dto_VMSConfigurationSchema = z.object({
    _id: z.string(),
    organisationIds: z.array(z.string()).nullable(),
    vms: Services_vmx_pkg_vms_TypeSchema,
    weekCycles: z.array(vmx_pkg_vmsconfiguration_dto_WeekCycleSchema).nullish(),
    createdAt: z.coerce.date().nullable(),
    updatedAt: z.coerce.date().nullable(),
});
